// This file is auto-generated by @hey-api/openapi-ts

import { type Options as ClientOptions, type TDataShape, type Client, urlSearchParamsBodySerializer, formDataBodySerializer } from '@hey-api/client-fetch';
import type { GetUserInfoApiV1UsersMeGetData, GetUserInfoApiV1UsersMeGetResponses, GetUserInfoApiV1UsersMeGetErrors, RequestOtpApiV1AuthRequestOtpPostData, RequestOtpApiV1AuthRequestOtpPostResponses, RequestOtpApiV1AuthRequestOtpPostErrors, VerifyOtpApiV1AuthVerifyOtpPostData, VerifyOtpApiV1AuthVerifyOtpPostResponses, VerifyOtpApiV1AuthVerifyOtpPostErrors, RefreshApiV1AuthRefreshPostData, RefreshApiV1AuthRefreshPostResponses, LogoutApiV1AuthLogoutPostData, LogoutApiV1AuthLogoutPostResponses, GetFileContentApiV1FilesFileIdContentGetData, GetFileContentApiV1FilesFileIdContentGetResponses, GetFileContentApiV1FilesFileIdContentGetErrors, GetFileUploadSasUrlApiV1FilesUploadSasUrlPostData, GetFileUploadSasUrlApiV1FilesUploadSasUrlPostResponses, GetFileUploadSasUrlApiV1FilesUploadSasUrlPostErrors, HeartbeatFileUploadApiV1FilesUploadsUploadIdHeartbeatPostData, HeartbeatFileUploadApiV1FilesUploadsUploadIdHeartbeatPostResponses, HeartbeatFileUploadApiV1FilesUploadsUploadIdHeartbeatPostErrors, FinishFileUploadApiV1FilesUploadsUploadIdDeleteData, FinishFileUploadApiV1FilesUploadsUploadIdDeleteResponses, FinishFileUploadApiV1FilesUploadsUploadIdDeleteErrors, GetAllFilesApiV1FilesGetData, GetAllFilesApiV1FilesGetResponses, GetAllFilesApiV1FilesGetErrors, RemoveFileApiV1FilesIdDeleteData, RemoveFileApiV1FilesIdDeleteResponses, RemoveFileApiV1FilesIdDeleteErrors, GetFileApiV1FilesIdGetData, GetFileApiV1FilesIdGetResponses, GetFileApiV1FilesIdGetErrors, UpdateFileMetadataEndpointApiV1FilesIdPatchData, UpdateFileMetadataEndpointApiV1FilesIdPatchResponses, UpdateFileMetadataEndpointApiV1FilesIdPatchErrors, UploadFileApiV1FilesUploadPostData, UploadFileApiV1FilesUploadPostResponses, UploadFileApiV1FilesUploadPostErrors, RetrySummaryGenerationApiV1FilesIdRetrySummaryGenerationPostData, RetrySummaryGenerationApiV1FilesIdRetrySummaryGenerationPostResponses, RetrySummaryGenerationApiV1FilesIdRetrySummaryGenerationPostErrors, ReindexFileApiV1FilesIdReindexPostData, ReindexFileApiV1FilesIdReindexPostResponses, ReindexFileApiV1FilesIdReindexPostErrors, UpdateFullSummaryApiV1FilesIdUpdateFullSummaryPutData, UpdateFullSummaryApiV1FilesIdUpdateFullSummaryPutResponses, UpdateFullSummaryApiV1FilesIdUpdateFullSummaryPutErrors, UpdateDocumentReviewStatusEndpointApiV1FilesIdUpdateDocumentReviewStatusPutData, UpdateDocumentReviewStatusEndpointApiV1FilesIdUpdateDocumentReviewStatusPutResponses, UpdateDocumentReviewStatusEndpointApiV1FilesIdUpdateDocumentReviewStatusPutErrors, UpdateClassificationApiV1FilesIdUpdateClassificationPutData, UpdateClassificationApiV1FilesIdUpdateClassificationPutResponses, UpdateClassificationApiV1FilesIdUpdateClassificationPutErrors, BatchRemoveFilesApiV1FilesBatchDeletePostData, BatchRemoveFilesApiV1FilesBatchDeletePostResponses, BatchRemoveFilesApiV1FilesBatchDeletePostErrors, ResetUserFolderApiV1FilesResetUserIdDeleteData, ResetUserFolderApiV1FilesResetUserIdDeleteResponses, ResetUserFolderApiV1FilesResetUserIdDeleteErrors, MergeFilesApiV1FilesMergePostData, MergeFilesApiV1FilesMergePostResponses, MergeFilesApiV1FilesMergePostErrors, UnmergeFileApiV1FilesIdUnmergePostData, UnmergeFileApiV1FilesIdUnmergePostResponses, UnmergeFileApiV1FilesIdUnmergePostErrors, GetClassificationsApiV1FilesClassificationsGetData, GetClassificationsApiV1FilesClassificationsGetResponses, GetClassificationsApiV1FilesClassificationsGetErrors, ExtractExamineeAndClaimNumberApiV1CasesExtractInfoPostData, ExtractExamineeAndClaimNumberApiV1CasesExtractInfoPostResponses, ExtractExamineeAndClaimNumberApiV1CasesExtractInfoPostErrors, GetAllCasesApiV1CasesGetData, GetAllCasesApiV1CasesGetResponses, GetAllCasesApiV1CasesGetErrors, CreateCaseEndpointApiV1CasesPostData, CreateCaseEndpointApiV1CasesPostResponses, CreateCaseEndpointApiV1CasesPostErrors, CreateReferrerCaseEndpointApiV1CasesReferrerIntakePostData, CreateReferrerCaseEndpointApiV1CasesReferrerIntakePostResponses, CreateReferrerCaseEndpointApiV1CasesReferrerIntakePostErrors, DeleteCaseEndpointApiV1CasesCaseIdDeleteData, DeleteCaseEndpointApiV1CasesCaseIdDeleteResponses, DeleteCaseEndpointApiV1CasesCaseIdDeleteErrors, GetCaseEndpointApiV1CasesCaseIdGetData, GetCaseEndpointApiV1CasesCaseIdGetResponses, GetCaseEndpointApiV1CasesCaseIdGetErrors, UpdateCaseEndpointApiV1CasesCaseIdPatchData, UpdateCaseEndpointApiV1CasesCaseIdPatchResponses, UpdateCaseEndpointApiV1CasesCaseIdPatchErrors, GetCaseReportTemplateApiV1CasesCaseIdReportTemplateGetData, GetCaseReportTemplateApiV1CasesCaseIdReportTemplateGetResponses, GetCaseReportTemplateApiV1CasesCaseIdReportTemplateGetErrors, GetCaseByCaseNumberEndpointApiV1CasesGetCaseByCaseNumberCaseNumberGetData, GetCaseByCaseNumberEndpointApiV1CasesGetCaseByCaseNumberCaseNumberGetResponses, GetCaseByCaseNumberEndpointApiV1CasesGetCaseByCaseNumberCaseNumberGetErrors, ExportCaseEndpointApiV1CasesCaseIdExportPostData, ExportCaseEndpointApiV1CasesCaseIdExportPostResponses, ExportCaseEndpointApiV1CasesCaseIdExportPostErrors, CheckExportingFilesApiV1CasesCaseNumberCheckExportingFilesGetData, CheckExportingFilesApiV1CasesCaseNumberCheckExportingFilesGetResponses, CheckExportingFilesApiV1CasesCaseNumberCheckExportingFilesGetErrors, GetCaseProcessingStatusApiV1CasesCaseNumberProcessingStatusGetData, GetCaseProcessingStatusApiV1CasesCaseNumberProcessingStatusGetResponses, GetCaseProcessingStatusApiV1CasesCaseNumberProcessingStatusGetErrors, GetTemplateOutlineApiV1CasesGetCaseByCaseNumberCaseNumberTemplateOutlineGetData, GetTemplateOutlineApiV1CasesGetCaseByCaseNumberCaseNumberTemplateOutlineGetResponses, GetTemplateOutlineApiV1CasesGetCaseByCaseNumberCaseNumberTemplateOutlineGetErrors, SaveAssessmentApiV1AssessmentPostData, SaveAssessmentApiV1AssessmentPostResponses, SaveAssessmentApiV1AssessmentPostErrors, GetAssessmentByCaseNumberApiV1AssessmentCaseCaseNumberGetData, GetAssessmentByCaseNumberApiV1AssessmentCaseCaseNumberGetResponses, GetAssessmentByCaseNumberApiV1AssessmentCaseCaseNumberGetErrors, UpdateAssessmentApiV1AssessmentAssessmentIdPatchData, UpdateAssessmentApiV1AssessmentAssessmentIdPatchResponses, UpdateAssessmentApiV1AssessmentAssessmentIdPatchErrors, UpdateFieldStatusesApiV1AssessmentAssessmentIdFieldStatusPatchData, UpdateFieldStatusesApiV1AssessmentAssessmentIdFieldStatusPatchResponses, UpdateFieldStatusesApiV1AssessmentAssessmentIdFieldStatusPatchErrors, TranscribeAndSummarizeAudioApiV1TranscriptionSummarizePostData, TranscribeAndSummarizeAudioApiV1TranscriptionSummarizePostResponses, TranscribeAndSummarizeAudioApiV1TranscriptionSummarizePostErrors, RetryTranscriptionSummaryApiV1TranscriptionSummarizeRetryPostData, RetryTranscriptionSummaryApiV1TranscriptionSummarizeRetryPostResponses, RetryTranscriptionSummaryApiV1TranscriptionSummarizeRetryPostErrors, GetTranscriptionSummaryStatusApiV1TranscriptionSummaryStatusTaskIdGetData, GetTranscriptionSummaryStatusApiV1TranscriptionSummaryStatusTaskIdGetResponses, GetTranscriptionSummaryStatusApiV1TranscriptionSummaryStatusTaskIdGetErrors, QueryTranscriptApiV1TranscriptionQueryTranscriptPostData, QueryTranscriptApiV1TranscriptionQueryTranscriptPostResponses, QueryTranscriptApiV1TranscriptionQueryTranscriptPostErrors, ConfirmRecordingConsentApiV1TranscriptionConsentPostData, ConfirmRecordingConsentApiV1TranscriptionConsentPostResponses, ConfirmRecordingConsentApiV1TranscriptionConsentPostErrors, GetStreamingTokenApiV1TranscriptionStreamingTokenPostData, GetStreamingTokenApiV1TranscriptionStreamingTokenPostResponses, GetStreamingTokenApiV1TranscriptionStreamingTokenPostErrors, GetAzureSpeechTokenApiV1TranscriptionAzureSpeechTokenPostData, GetAzureSpeechTokenApiV1TranscriptionAzureSpeechTokenPostResponses, GetAzureSpeechTokenApiV1TranscriptionAzureSpeechTokenPostErrors, QueryCosmosApiV1CosmosQueryPostData, QueryCosmosApiV1CosmosQueryPostResponses, QueryCosmosApiV1CosmosQueryPostErrors, ListQuickLookupsApiV1CosmosQuickLookupsGetData, ListQuickLookupsApiV1CosmosQuickLookupsGetResponses, ListQuickLookupsApiV1CosmosQuickLookupsGetErrors, GetResponseDraftDocxApiV1ReportGeneratorResponsesResponseIdDraftDocxGetData, GetResponseDraftDocxApiV1ReportGeneratorResponsesResponseIdDraftDocxGetResponses, GetResponseDraftDocxApiV1ReportGeneratorResponsesResponseIdDraftDocxGetErrors, GetAllExportedCasesApiV1ReportGeneratorExportedCasesGetData, GetAllExportedCasesApiV1ReportGeneratorExportedCasesGetResponses, GetAllExportedFilesApiV1ReportGeneratorExportedCasesCaseIdFilesGetData, GetAllExportedFilesApiV1ReportGeneratorExportedCasesCaseIdFilesGetResponses, GetAllExportedFilesApiV1ReportGeneratorExportedCasesCaseIdFilesGetErrors, DeleteExportedFileApiV1ReportGeneratorExportedFileIdDeleteData, DeleteExportedFileApiV1ReportGeneratorExportedFileIdDeleteResponses, DeleteExportedFileApiV1ReportGeneratorExportedFileIdDeleteErrors, GetCodeOfConductEntriesApiV1ReportGeneratorCodeOfConductGetData, GetCodeOfConductEntriesApiV1ReportGeneratorCodeOfConductGetResponses, GetAllTemplatesApiV1ReportGeneratorTemplatesGetData, GetAllTemplatesApiV1ReportGeneratorTemplatesGetResponses, GetAllTemplatesApiV1ReportGeneratorTemplatesGetErrors, CreateTemplateApiV1ReportGeneratorTemplatesPostData, CreateTemplateApiV1ReportGeneratorTemplatesPostResponses, CreateTemplateApiV1ReportGeneratorTemplatesPostErrors, DeleteTemplateApiV1ReportGeneratorTemplatesIdDeleteData, DeleteTemplateApiV1ReportGeneratorTemplatesIdDeleteResponses, DeleteTemplateApiV1ReportGeneratorTemplatesIdDeleteErrors, GetTemplateApiV1ReportGeneratorTemplatesIdGetData, GetTemplateApiV1ReportGeneratorTemplatesIdGetResponses, GetTemplateApiV1ReportGeneratorTemplatesIdGetErrors, UpdateTemplateApiV1ReportGeneratorTemplatesIdPutData, UpdateTemplateApiV1ReportGeneratorTemplatesIdPutResponses, UpdateTemplateApiV1ReportGeneratorTemplatesIdPutErrors, GetTemplateRawDocxApiV1ReportGeneratorTemplatesIdRawDocxGetData, GetTemplateRawDocxApiV1ReportGeneratorTemplatesIdRawDocxGetResponses, GetTemplateRawDocxApiV1ReportGeneratorTemplatesIdRawDocxGetErrors, GetUserInitialAnswersApiV1ReportGeneratorTemplatesIdCasesCaseNumberGetUserInitialAnswersPostData, GetUserInitialAnswersApiV1ReportGeneratorTemplatesIdCasesCaseNumberGetUserInitialAnswersPostResponses, GetUserInitialAnswersApiV1ReportGeneratorTemplatesIdCasesCaseNumberGetUserInitialAnswersPostErrors, RegenerateApiV1ReportGeneratorTemplatesIdCasesCaseNumberRegeneratePostData, RegenerateApiV1ReportGeneratorTemplatesIdCasesCaseNumberRegeneratePostResponses, RegenerateApiV1ReportGeneratorTemplatesIdCasesCaseNumberRegeneratePostErrors, SynthesizeApiV1ReportGeneratorTemplatesIdCasesCaseNumberSynthesizePostData, SynthesizeApiV1ReportGeneratorTemplatesIdCasesCaseNumberSynthesizePostResponses, SynthesizeApiV1ReportGeneratorTemplatesIdCasesCaseNumberSynthesizePostErrors, AnswerQuestionsApiV1ReportGeneratorTemplatesIdCasesCaseNumberAnswerQuestionsPostData, AnswerQuestionsApiV1ReportGeneratorTemplatesIdCasesCaseNumberAnswerQuestionsPostResponses, AnswerQuestionsApiV1ReportGeneratorTemplatesIdCasesCaseNumberAnswerQuestionsPostErrors, SaveDraftApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveDraftPostData, SaveDraftApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveDraftPostResponses, SaveDraftApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveDraftPostErrors, CheckDraftStatusApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftStatusGetData, CheckDraftStatusApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftStatusGetResponses, CheckDraftStatusApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftStatusGetErrors, GetDraftReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftReportGetData, GetDraftReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftReportGetResponses, GetDraftReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftReportGetErrors, CompleteResponseApiV1ReportGeneratorResponsesResponseIdCompletePutData, CompleteResponseApiV1ReportGeneratorResponsesResponseIdCompletePutResponses, CompleteResponseApiV1ReportGeneratorResponsesResponseIdCompletePutErrors, ClaimReportEditorLeaseApiV1ReportGeneratorResponsesResponseIdEditorLeasePostData, ClaimReportEditorLeaseApiV1ReportGeneratorResponsesResponseIdEditorLeasePostResponses, ClaimReportEditorLeaseApiV1ReportGeneratorResponsesResponseIdEditorLeasePostErrors, GetResponseByIdApiV1ReportGeneratorResponsesResponseIdGetData, GetResponseByIdApiV1ReportGeneratorResponsesResponseIdGetResponses, GetResponseByIdApiV1ReportGeneratorResponsesResponseIdGetErrors, UploadDraftDocxApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftDocxPutData, UploadDraftDocxApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftDocxPutResponses, UploadDraftDocxApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftDocxPutErrors, GetSourceSnippetsApiV1ReportGeneratorTemplatesIdCasesCaseNumberSourceSnippetsGetData, GetSourceSnippetsApiV1ReportGeneratorTemplatesIdCasesCaseNumberSourceSnippetsGetResponses, GetSourceSnippetsApiV1ReportGeneratorTemplatesIdCasesCaseNumberSourceSnippetsGetErrors, GenerateReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateReportPostData, GenerateReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateReportPostResponses, GenerateReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateReportPostErrors, SaveReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveReportPostData, SaveReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveReportPostResponses, SaveReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveReportPostErrors, PreviewReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberPreviewReportPostData, PreviewReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberPreviewReportPostResponses, PreviewReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberPreviewReportPostErrors, GenerateFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateFromHtmlPostData, GenerateFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateFromHtmlPostResponses, GenerateFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateFromHtmlPostErrors, DownloadResponseAsPdfApiV1ReportGeneratorResponsesResponseIdDownloadPdfPostData, DownloadResponseAsPdfApiV1ReportGeneratorResponsesResponseIdDownloadPdfPostResponses, DownloadResponseAsPdfApiV1ReportGeneratorResponsesResponseIdDownloadPdfPostErrors, PreviewResponseAsPdfApiV1ReportGeneratorResponsesResponseIdPreviewPdfPostData, PreviewResponseAsPdfApiV1ReportGeneratorResponsesResponseIdPreviewPdfPostResponses, PreviewResponseAsPdfApiV1ReportGeneratorResponsesResponseIdPreviewPdfPostErrors, DownloadResponseAsDocxApiV1ReportGeneratorResponsesResponseIdDownloadDocxGetData, DownloadResponseAsDocxApiV1ReportGeneratorResponsesResponseIdDownloadDocxGetResponses, DownloadResponseAsDocxApiV1ReportGeneratorResponsesResponseIdDownloadDocxGetErrors, GeneratePdfFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGeneratePdfFromHtmlPostData, GeneratePdfFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGeneratePdfFromHtmlPostResponses, GeneratePdfFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGeneratePdfFromHtmlPostErrors, RenderTemplateHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberRenderHtmlPostData, RenderTemplateHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberRenderHtmlPostResponses, RenderTemplateHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberRenderHtmlPostErrors, GetGeneratedReportsApiV1ReportGeneratorCasesCaseNumberGeneratedReportsGetData, GetGeneratedReportsApiV1ReportGeneratorCasesCaseNumberGeneratedReportsGetResponses, GetGeneratedReportsApiV1ReportGeneratorCasesCaseNumberGeneratedReportsGetErrors, RefineExpertsCommentaryApiV1ReportGeneratorRefineExpertsCommentaryPostData, RefineExpertsCommentaryApiV1ReportGeneratorRefineExpertsCommentaryPostResponses, RefineExpertsCommentaryApiV1ReportGeneratorRefineExpertsCommentaryPostErrors, RunReportQaRouteApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaPostData, RunReportQaRouteApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaPostResponses, RunReportQaRouteApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaPostErrors, GetLatestReportQaApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaLatestGetData, GetLatestReportQaApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaLatestGetResponses, GetLatestReportQaApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaLatestGetErrors, ListModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsGetData, ListModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsGetResponses, ListModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsGetErrors, MapExtractToModulesApiV1ReportGeneratorCasesCaseNumberModuleExtractsPostData, MapExtractToModulesApiV1ReportGeneratorCasesCaseNumberModuleExtractsPostResponses, MapExtractToModulesApiV1ReportGeneratorCasesCaseNumberModuleExtractsPostErrors, ReorderModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsOrderPatchData, ReorderModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsOrderPatchResponses, ReorderModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsOrderPatchErrors, DeleteModuleExtractApiV1ReportGeneratorModuleExtractsExtractIdDeleteData, DeleteModuleExtractApiV1ReportGeneratorModuleExtractsExtractIdDeleteResponses, DeleteModuleExtractApiV1ReportGeneratorModuleExtractsExtractIdDeleteErrors, RetryAutoMapLoiApiV1ReportGeneratorCasesCaseNumberAutoMapLoiPostData, RetryAutoMapLoiApiV1ReportGeneratorCasesCaseNumberAutoMapLoiPostResponses, RetryAutoMapLoiApiV1ReportGeneratorCasesCaseNumberAutoMapLoiPostErrors, FinaliseResponseApiV1ReportGeneratorResponsesResponseIdFinalisePostData, FinaliseResponseApiV1ReportGeneratorResponsesResponseIdFinalisePostResponses, FinaliseResponseApiV1ReportGeneratorResponsesResponseIdFinalisePostErrors, UnlockResponseApiV1ReportGeneratorResponsesResponseIdUnlockPostData, UnlockResponseApiV1ReportGeneratorResponsesResponseIdUnlockPostResponses, UnlockResponseApiV1ReportGeneratorResponsesResponseIdUnlockPostErrors, MarkResponseVinciUploadedApiV1ReportGeneratorResponsesResponseIdMarkVinciUploadedPostData, MarkResponseVinciUploadedApiV1ReportGeneratorResponsesResponseIdMarkVinciUploadedPostResponses, MarkResponseVinciUploadedApiV1ReportGeneratorResponsesResponseIdMarkVinciUploadedPostErrors, GetFinalisationStateApiV1ReportGeneratorResponsesResponseIdFinalisationStateGetData, GetFinalisationStateApiV1ReportGeneratorResponsesResponseIdFinalisationStateGetResponses, GetFinalisationStateApiV1ReportGeneratorResponsesResponseIdFinalisationStateGetErrors, HealthCheckApiV1BundleSplitterHealthGetData, HealthCheckApiV1BundleSplitterHealthGetResponses, GetBundleSplitterSasTokenApiV1BundleSplitterGetSasTokenPostData, GetBundleSplitterSasTokenApiV1BundleSplitterGetSasTokenPostResponses, GetBundleSplitterSasTokenApiV1BundleSplitterGetSasTokenPostErrors, ClassifyFilesApiV1BundleSplitterClassifyPostData, ClassifyFilesApiV1BundleSplitterClassifyPostResponses, ClassifyFilesApiV1BundleSplitterClassifyPostErrors, HeartbeatBundleUploadApiV1BundleSplitterUploadsUploadIdHeartbeatPostData, HeartbeatBundleUploadApiV1BundleSplitterUploadsUploadIdHeartbeatPostResponses, HeartbeatBundleUploadApiV1BundleSplitterUploadsUploadIdHeartbeatPostErrors, AbandonBundleUploadApiV1BundleSplitterUploadsUploadIdAbandonPostData, AbandonBundleUploadApiV1BundleSplitterUploadsUploadIdAbandonPostResponses, AbandonBundleUploadApiV1BundleSplitterUploadsUploadIdAbandonPostErrors, GetTaskStatusApiV1BundleSplitterTasksTaskIdStatusGetData, GetTaskStatusApiV1BundleSplitterTasksTaskIdStatusGetResponses, GetTaskStatusApiV1BundleSplitterTasksTaskIdStatusGetErrors, GetTaskResultApiV1BundleSplitterTasksTaskIdResultGetData, GetTaskResultApiV1BundleSplitterTasksTaskIdResultGetResponses, GetTaskResultApiV1BundleSplitterTasksTaskIdResultGetErrors, CancelTaskApiV1BundleSplitterTasksTaskIdCancelPostData, CancelTaskApiV1BundleSplitterTasksTaskIdCancelPostResponses, CancelTaskApiV1BundleSplitterTasksTaskIdCancelPostErrors, ClassifyFilesByRequestApiV1BundleSplitterClassifyByRequestPostData, ClassifyFilesByRequestApiV1BundleSplitterClassifyByRequestPostResponses, ClassifyFilesByRequestApiV1BundleSplitterClassifyByRequestPostErrors, SaveClassifiedFilesApiV1BundleSplitterCaseCaseNumberSavePostData, SaveClassifiedFilesApiV1BundleSplitterCaseCaseNumberSavePostResponses, SaveClassifiedFilesApiV1BundleSplitterCaseCaseNumberSavePostErrors, ListBundleSplitterTasksApiV1BundleSplitterTasksGetData, ListBundleSplitterTasksApiV1BundleSplitterTasksGetResponses, ListBundleSplitterTasksApiV1BundleSplitterTasksGetErrors, ExtractSnipTextApiV1OcrSnipExtractPostData, ExtractSnipTextApiV1OcrSnipExtractPostResponses, ExtractSnipTextApiV1OcrSnipExtractPostErrors, GetPageOcrLinesApiV1OcrSnipLinesPostData, GetPageOcrLinesApiV1OcrSnipLinesPostResponses, GetPageOcrLinesApiV1OcrSnipLinesPostErrors, GetSuremedRequestFormsApiV1ProvidersSuremedRequestFormsGetData, GetSuremedRequestFormsApiV1ProvidersSuremedRequestFormsGetResponses, ListDocumentRequestsApiV1CasesCaseIdDocumentRequestsGetData, ListDocumentRequestsApiV1CasesCaseIdDocumentRequestsGetResponses, ListDocumentRequestsApiV1CasesCaseIdDocumentRequestsGetErrors, CreateDocumentRequestApiV1CasesCaseIdDocumentRequestsPostData, CreateDocumentRequestApiV1CasesCaseIdDocumentRequestsPostResponses, CreateDocumentRequestApiV1CasesCaseIdDocumentRequestsPostErrors, RefreshDocumentRequestApiV1CasesCaseIdDocumentRequestsRequestIdRefreshPostData, RefreshDocumentRequestApiV1CasesCaseIdDocumentRequestsRequestIdRefreshPostResponses, RefreshDocumentRequestApiV1CasesCaseIdDocumentRequestsRequestIdRefreshPostErrors, ListProviderRequestsApiV1ProvidersMeDocumentRequestsGetData, ListProviderRequestsApiV1ProvidersMeDocumentRequestsGetResponses, GetProviderRequestApiV1ProvidersMeDocumentRequestsRequestIdGetData, GetProviderRequestApiV1ProvidersMeDocumentRequestsRequestIdGetResponses, GetProviderRequestApiV1ProvidersMeDocumentRequestsRequestIdGetErrors, GetTagsApiV1TagsGetData, GetTagsApiV1TagsGetResponses, SearchVinciApiV1AdminAccessListVinciSearchGetData, SearchVinciApiV1AdminAccessListVinciSearchGetResponses, SearchVinciApiV1AdminAccessListVinciSearchGetErrors, ListEntriesApiV1AdminAccessListGetData, ListEntriesApiV1AdminAccessListGetResponses, ListEntriesApiV1AdminAccessListGetErrors, CreateEntryApiV1AdminAccessListPostData, CreateEntryApiV1AdminAccessListPostResponses, CreateEntryApiV1AdminAccessListPostErrors, DeleteEntryApiV1AdminAccessListEntryIdDeleteData, DeleteEntryApiV1AdminAccessListEntryIdDeleteResponses, DeleteEntryApiV1AdminAccessListEntryIdDeleteErrors, UpdateEntryApiV1AdminAccessListEntryIdPatchData, UpdateEntryApiV1AdminAccessListEntryIdPatchResponses, UpdateEntryApiV1AdminAccessListEntryIdPatchErrors, GetCatalogueApiV1AdminAccessConfigCatalogueGetData, GetCatalogueApiV1AdminAccessConfigCatalogueGetResponses, ListAccessConfigApiV1AdminAccessConfigGetData, ListAccessConfigApiV1AdminAccessConfigGetResponses, ResetAccessConfigApiV1AdminAccessConfigUserTypeDeleteData, ResetAccessConfigApiV1AdminAccessConfigUserTypeDeleteResponses, ResetAccessConfigApiV1AdminAccessConfigUserTypeDeleteErrors, SetAccessConfigApiV1AdminAccessConfigUserTypePutData, SetAccessConfigApiV1AdminAccessConfigUserTypePutResponses, SetAccessConfigApiV1AdminAccessConfigUserTypePutErrors, ListUsersApiV1AdminUsersGetData, ListUsersApiV1AdminUsersGetResponses, ListUsersApiV1AdminUsersGetErrors, UpdateUserApiV1AdminUsersUserIdPatchData, UpdateUserApiV1AdminUsersUserIdPatchResponses, UpdateUserApiV1AdminUsersUserIdPatchErrors, AssignCaseReferrerApiV1AdminCasesCaseIdReferrerPatchData, AssignCaseReferrerApiV1AdminCasesCaseIdReferrerPatchResponses, AssignCaseReferrerApiV1AdminCasesCaseIdReferrerPatchErrors, AssignCaseDoctorApiV1AdminCasesCaseIdDoctorPatchData, AssignCaseDoctorApiV1AdminCasesCaseIdDoctorPatchResponses, AssignCaseDoctorApiV1AdminCasesCaseIdDoctorPatchErrors, SetCaseDoctorReadyApiV1AdminCasesCaseIdDoctorReadyPatchData, SetCaseDoctorReadyApiV1AdminCasesCaseIdDoctorReadyPatchResponses, SetCaseDoctorReadyApiV1AdminCasesCaseIdDoctorReadyPatchErrors, ListAuditEventsApiV1AdminAuditEventsGetData, ListAuditEventsApiV1AdminAuditEventsGetResponses, ListAuditEventsApiV1AdminAuditEventsGetErrors, IngestBookingApprovalApiV1IntakeBookingApprovalsPostData, IngestBookingApprovalApiV1IntakeBookingApprovalsPostResponses, IngestBookingApprovalApiV1IntakeBookingApprovalsPostErrors, ListBookingApprovalsApiV1BookingApprovalsGetData, ListBookingApprovalsApiV1BookingApprovalsGetResponses, ListBookingApprovalsApiV1BookingApprovalsGetErrors, TriggerBookingSyncApiV1BookingApprovalsSyncPostData, TriggerBookingSyncApiV1BookingApprovalsSyncPostResponses, TriggerBookingSyncApiV1BookingApprovalsSyncPostErrors, GetBookingApprovalApiV1BookingApprovalsApprovalIdGetData, GetBookingApprovalApiV1BookingApprovalsApprovalIdGetResponses, GetBookingApprovalApiV1BookingApprovalsApprovalIdGetErrors, ApproveBookingApprovalApiV1BookingApprovalsApprovalIdApprovePostData, ApproveBookingApprovalApiV1BookingApprovalsApprovalIdApprovePostResponses, ApproveBookingApprovalApiV1BookingApprovalsApprovalIdApprovePostErrors, RejectBookingApprovalApiV1BookingApprovalsApprovalIdRejectPostData, RejectBookingApprovalApiV1BookingApprovalsApprovalIdRejectPostResponses, RejectBookingApprovalApiV1BookingApprovalsApprovalIdRejectPostErrors, IngestCaseDocumentsApiV1VinciCasesCaseIdIngestDocumentsPostData, IngestCaseDocumentsApiV1VinciCasesCaseIdIngestDocumentsPostResponses, IngestCaseDocumentsApiV1VinciCasesCaseIdIngestDocumentsPostErrors, MainGetData, MainGetResponses } from './types.gen';
import { client as _heyApiClient } from './client.gen';

export type Options<TData extends TDataShape = TDataShape, ThrowOnError extends boolean = boolean> = ClientOptions<TData, ThrowOnError> & {
    /**
     * You can provide a client instance returned by `createClient()` instead of
     * individual options. This might be also useful if you want to implement a
     * custom client.
     */
    client?: Client;
    /**
     * You can pass arbitrary values through the `meta` object. This can be
     * used to access values that aren't defined as part of the SDK function.
     */
    meta?: Record<string, unknown>;
};

/**
 * Get User Info
 */
export const getUserInfoApiV1UsersMeGet = <ThrowOnError extends boolean = false>(options?: Options<GetUserInfoApiV1UsersMeGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetUserInfoApiV1UsersMeGetResponses, GetUserInfoApiV1UsersMeGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/users/me',
        ...options
    });
};

/**
 * Request Otp
 * Email a one-time code — but only if the email is approved + in Vinci.
 *
 * Always returns the same generic message (AC #2).
 */
export const requestOtpApiV1AuthRequestOtpPost = <ThrowOnError extends boolean = false>(options: Options<RequestOtpApiV1AuthRequestOtpPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RequestOtpApiV1AuthRequestOtpPostResponses, RequestOtpApiV1AuthRequestOtpPostErrors, ThrowOnError>({
        url: '/api/v1/auth/request-otp',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Verify Otp
 * Verify the code, issue a short-lived access token, and set the
 * httpOnly refresh-token cookie that keeps the session alive (MDRS-556).
 */
export const verifyOtpApiV1AuthVerifyOtpPost = <ThrowOnError extends boolean = false>(options: Options<VerifyOtpApiV1AuthVerifyOtpPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<VerifyOtpApiV1AuthVerifyOtpPostResponses, VerifyOtpApiV1AuthVerifyOtpPostErrors, ThrowOnError>({
        url: '/api/v1/auth/verify-otp',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Refresh
 * Exchange the httpOnly refresh-token cookie for a new access token.
 *
 * The frontend equivalent of MSAL's ssoSilent() for external users — called
 * on bootstrap when there's no in-memory access token, and on a 401 retry,
 * so a tab never needs to persist the access token itself anywhere.
 */
export const refreshApiV1AuthRefreshPost = <ThrowOnError extends boolean = false>(options?: Options<RefreshApiV1AuthRefreshPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<RefreshApiV1AuthRefreshPostResponses, unknown, ThrowOnError>({
        url: '/api/v1/auth/refresh',
        ...options
    });
};

/**
 * Logout
 * Revoke the refresh-token family and clear the cookie.
 *
 * Real server-side revocation (MDRS-556) — but scoped to this endpoint
 * only. The frontend must call this only from an explicit user-initiated
 * logout, never from a defensive/automatic cleanup path (MDRS-383's
 * cba2ce0b: revoking from ~15 defensive call sites turned one flaky
 * request anywhere into a permanent, surprise sign-out).
 */
export const logoutApiV1AuthLogoutPost = <ThrowOnError extends boolean = false>(options?: Options<LogoutApiV1AuthLogoutPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<LogoutApiV1AuthLogoutPostResponses, unknown, ThrowOnError>({
        url: '/api/v1/auth/logout',
        ...options
    });
};

/**
 * Get File Content
 * Stream a case document's bytes back to the caller (MDRS-503).
 *
 * Replaces ``GET /{file_id}/sas-url``. That endpoint minted a credentialed
 * URL straight to Azure, which meant the ownership check ran **once**, at mint
 * time — the fetch itself bypassed our API entirely, so the link worked for
 * anyone who obtained it until it expired. These are the examinee's clinical
 * documents, the most sensitive blobs we hold, so the standalone URL is gone:
 * the bytes come back over this authenticated request and ``get_file_for_user``
 * re-authorises on **every** fetch.
 *
 * Access is decided by the file's case (MDRS-235), and the route keeps the
 * same capability gate the file list has — this is still the raw document.
 *
 * Range requests are honoured so the PDF viewer can seek instead of pulling a
 * whole bundle to render page one.
 */
export const getFileContentApiV1FilesFileIdContentGet = <ThrowOnError extends boolean = false>(options: Options<GetFileContentApiV1FilesFileIdContentGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFileContentApiV1FilesFileIdContentGetResponses, GetFileContentApiV1FilesFileIdContentGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/{file_id}/content',
        ...options
    });
};

/**
 * Get File Upload Sas Url
 * Return a write-only SAS URL for a single blob path scoped to the
 * requesting user. Verifies the case belongs to the user before issuing.
 *
 * A case file also gets an in-flight upload marker (``upload_id``) that holds
 * finalise back until the file is registered. A consent PDF gets none: it is
 * never registered as a case document.
 */
export const getFileUploadSasUrlApiV1FilesUploadSasUrlPost = <ThrowOnError extends boolean = false>(options: Options<GetFileUploadSasUrlApiV1FilesUploadSasUrlPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetFileUploadSasUrlApiV1FilesUploadSasUrlPostResponses, GetFileUploadSasUrlApiV1FilesUploadSasUrlPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/upload-sas-url',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Heartbeat File Upload
 * Keep the caller's in-flight upload counting.
 *
 * 404 unless it's theirs and still counts.
 */
export const heartbeatFileUploadApiV1FilesUploadsUploadIdHeartbeatPost = <ThrowOnError extends boolean = false>(options: Options<HeartbeatFileUploadApiV1FilesUploadsUploadIdHeartbeatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<HeartbeatFileUploadApiV1FilesUploadsUploadIdHeartbeatPostResponses, HeartbeatFileUploadApiV1FilesUploadsUploadIdHeartbeatPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/uploads/{upload_id}/heartbeat',
        ...options
    });
};

/**
 * Finish File Upload
 * Drop the caller's marker for an upload that failed. 404 unless it's theirs.
 *
 * A registered file needs no call: ``/upload`` removes its marker.
 */
export const finishFileUploadApiV1FilesUploadsUploadIdDelete = <ThrowOnError extends boolean = false>(options: Options<FinishFileUploadApiV1FilesUploadsUploadIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<FinishFileUploadApiV1FilesUploadsUploadIdDeleteResponses, FinishFileUploadApiV1FilesUploadsUploadIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/uploads/{upload_id}',
        ...options
    });
};

/**
 * Get All Files
 */
export const getAllFilesApiV1FilesGet = <ThrowOnError extends boolean = false>(options?: Options<GetAllFilesApiV1FilesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllFilesApiV1FilesGetResponses, GetAllFilesApiV1FilesGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/',
        ...options
    });
};

/**
 * Remove File
 */
export const removeFileApiV1FilesIdDelete = <ThrowOnError extends boolean = false>(options: Options<RemoveFileApiV1FilesIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<RemoveFileApiV1FilesIdDeleteResponses, RemoveFileApiV1FilesIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/{id}',
        ...options
    });
};

/**
 * Get File
 */
export const getFileApiV1FilesIdGet = <ThrowOnError extends boolean = false>(options: Options<GetFileApiV1FilesIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFileApiV1FilesIdGetResponses, GetFileApiV1FilesIdGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/{id}',
        ...options
    });
};

/**
 * Update File Metadata Endpoint
 * Update file metadata (date, author, description)
 */
export const updateFileMetadataEndpointApiV1FilesIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateFileMetadataEndpointApiV1FilesIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateFileMetadataEndpointApiV1FilesIdPatchResponses, UpdateFileMetadataEndpointApiV1FilesIdPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Upload File
 */
export const uploadFileApiV1FilesUploadPost = <ThrowOnError extends boolean = false>(options: Options<UploadFileApiV1FilesUploadPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UploadFileApiV1FilesUploadPostResponses, UploadFileApiV1FilesUploadPostErrors, ThrowOnError>({
        ...urlSearchParamsBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/upload',
        ...options,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...options.headers
        }
    });
};

/**
 * Retry Summary Generation
 */
export const retrySummaryGenerationApiV1FilesIdRetrySummaryGenerationPost = <ThrowOnError extends boolean = false>(options: Options<RetrySummaryGenerationApiV1FilesIdRetrySummaryGenerationPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetrySummaryGenerationApiV1FilesIdRetrySummaryGenerationPostResponses, RetrySummaryGenerationApiV1FilesIdRetrySummaryGenerationPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/{id}/retry-summary-generation',
        ...options
    });
};

/**
 * Reindex File
 * Re-trigger semantic-search indexing for a single file.
 *
 * Backs the per-file Re-index UI affordance for files stuck at
 * indexing_status=FAILED, or for users who suspect a false-negative backfill.
 */
export const reindexFileApiV1FilesIdReindexPost = <ThrowOnError extends boolean = false>(options: Options<ReindexFileApiV1FilesIdReindexPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ReindexFileApiV1FilesIdReindexPostResponses, ReindexFileApiV1FilesIdReindexPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/{id}/reindex',
        ...options
    });
};

/**
 * Update Full Summary
 */
export const updateFullSummaryApiV1FilesIdUpdateFullSummaryPut = <ThrowOnError extends boolean = false>(options: Options<UpdateFullSummaryApiV1FilesIdUpdateFullSummaryPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateFullSummaryApiV1FilesIdUpdateFullSummaryPutResponses, UpdateFullSummaryApiV1FilesIdUpdateFullSummaryPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/{id}/update-full-summary',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Document Review Status Endpoint
 */
export const updateDocumentReviewStatusEndpointApiV1FilesIdUpdateDocumentReviewStatusPut = <ThrowOnError extends boolean = false>(options: Options<UpdateDocumentReviewStatusEndpointApiV1FilesIdUpdateDocumentReviewStatusPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateDocumentReviewStatusEndpointApiV1FilesIdUpdateDocumentReviewStatusPutResponses, UpdateDocumentReviewStatusEndpointApiV1FilesIdUpdateDocumentReviewStatusPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/{id}/update-document-review-status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Update Classification
 * Update the classification of an uploaded file.
 * This is useful when a user uploads a file with the wrong classification.
 * Also moves the file to the correct folder in Azure Blob Storage.
 */
export const updateClassificationApiV1FilesIdUpdateClassificationPut = <ThrowOnError extends boolean = false>(options: Options<UpdateClassificationApiV1FilesIdUpdateClassificationPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateClassificationApiV1FilesIdUpdateClassificationPutResponses, UpdateClassificationApiV1FilesIdUpdateClassificationPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/{id}/update-classification',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Batch Remove Files
 */
export const batchRemoveFilesApiV1FilesBatchDeletePost = <ThrowOnError extends boolean = false>(options: Options<BatchRemoveFilesApiV1FilesBatchDeletePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<BatchRemoveFilesApiV1FilesBatchDeletePostResponses, BatchRemoveFilesApiV1FilesBatchDeletePostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/batch-delete',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Reset User Folder
 */
export const resetUserFolderApiV1FilesResetUserIdDelete = <ThrowOnError extends boolean = false>(options: Options<ResetUserFolderApiV1FilesResetUserIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ResetUserFolderApiV1FilesResetUserIdDeleteResponses, ResetUserFolderApiV1FilesResetUserIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/reset/{user_id}',
        ...options
    });
};

/**
 * Merge Files
 * Merge multiple PDF files into a single document.
 *
 * - Downloads source PDFs from blob storage
 * - Merges them in the specified order
 * - Uploads merged PDF to blob storage
 * - Creates new DocSorterFile record
 * - Triggers AI summary generation
 * - Marks source files as merged
 * - Creates FileMerge history record
 */
export const mergeFilesApiV1FilesMergePost = <ThrowOnError extends boolean = false>(options: Options<MergeFilesApiV1FilesMergePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MergeFilesApiV1FilesMergePostResponses, MergeFilesApiV1FilesMergePostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/merge',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Unmerge File
 * Unmerge a merged file, restoring the original source files.
 *
 * - Finds merge history for the file
 * - Restores source files (sets is_merged_source = False)
 * - Deletes merged file from database and blob storage
 * - Deletes FileMerge history record
 */
export const unmergeFileApiV1FilesIdUnmergePost = <ThrowOnError extends boolean = false>(options: Options<UnmergeFileApiV1FilesIdUnmergePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnmergeFileApiV1FilesIdUnmergePostResponses, UnmergeFileApiV1FilesIdUnmergePostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/{id}/unmerge',
        ...options
    });
};

/**
 * Get Classifications
 * Get all document types ordered by their order field.
 */
export const getClassificationsApiV1FilesClassificationsGet = <ThrowOnError extends boolean = false>(options?: Options<GetClassificationsApiV1FilesClassificationsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetClassificationsApiV1FilesClassificationsGetResponses, GetClassificationsApiV1FilesClassificationsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/files/classifications',
        ...options
    });
};

/**
 * Extract Examinee And Claim Number
 * Extract examinee name and claim number from the uploaded document using Azure AI.
 */
export const extractExamineeAndClaimNumberApiV1CasesExtractInfoPost = <ThrowOnError extends boolean = false>(options: Options<ExtractExamineeAndClaimNumberApiV1CasesExtractInfoPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExtractExamineeAndClaimNumberApiV1CasesExtractInfoPostResponses, ExtractExamineeAndClaimNumberApiV1CasesExtractInfoPostErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/extract-info',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Get All Cases
 * Fetch all cases for the current user.
 * Optional filters:
 * - case_number: Filter by case number (partial match)
 * - claim_number: Filter by claim number (partial match)
 * - examinee_name: Filter by examinee name (partial match)
 * - search: Search across case_number, claim_number, and examinee_name fields (partial match)
 * - template_id: Filter by template ID
 * - created_at: Filter by created at date
 * - created_at_start: Filter by created at start date
 * - created_at_end: Filter by created at end date
 * - appointment_date: Filter by appointment date
 * - status: Filter by case status
 */
export const getAllCasesApiV1CasesGet = <ThrowOnError extends boolean = false>(options?: Options<GetAllCasesApiV1CasesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllCasesApiV1CasesGetResponses, GetAllCasesApiV1CasesGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/',
        ...options
    });
};

/**
 * Create Case Endpoint
 */
export const createCaseEndpointApiV1CasesPost = <ThrowOnError extends boolean = false>(options: Options<CreateCaseEndpointApiV1CasesPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateCaseEndpointApiV1CasesPostResponses, CreateCaseEndpointApiV1CasesPostErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Create Referrer Case Endpoint
 * Lightweight intake case creation (MDRS-157).
 *
 * A new workflow: previously cases were created only via a Vinci booking or by
 * a doctor uploading a report template. This creates a lightweight intake case
 * — no report template / .docx required — gated by ``CASES_CREATE`` (admin /
 * doctor / internal; referrers are read-only). The caller is the owner
 * (``user_id``); the assigned referrer (``referrer_user_id``, which drives the
 * referrer's read-only case list) is resolved from ``referrer_email`` when the
 * caller creates on a referrer's behalf, else defaults to the caller. From the
 * case a document request can be raised to a provider (SureMed).
 */
export const createReferrerCaseEndpointApiV1CasesReferrerIntakePost = <ThrowOnError extends boolean = false>(options: Options<CreateReferrerCaseEndpointApiV1CasesReferrerIntakePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateReferrerCaseEndpointApiV1CasesReferrerIntakePostResponses, CreateReferrerCaseEndpointApiV1CasesReferrerIntakePostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/referrer-intake',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Case Endpoint
 */
export const deleteCaseEndpointApiV1CasesCaseIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteCaseEndpointApiV1CasesCaseIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteCaseEndpointApiV1CasesCaseIdDeleteResponses, DeleteCaseEndpointApiV1CasesCaseIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/{case_id}',
        ...options
    });
};

/**
 * Get Case Endpoint
 */
export const getCaseEndpointApiV1CasesCaseIdGet = <ThrowOnError extends boolean = false>(options: Options<GetCaseEndpointApiV1CasesCaseIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCaseEndpointApiV1CasesCaseIdGetResponses, GetCaseEndpointApiV1CasesCaseIdGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/{case_id}',
        ...options
    });
};

/**
 * Update Case Endpoint
 */
export const updateCaseEndpointApiV1CasesCaseIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateCaseEndpointApiV1CasesCaseIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateCaseEndpointApiV1CasesCaseIdPatchResponses, UpdateCaseEndpointApiV1CasesCaseIdPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/{case_id}',
        ...options
    });
};

/**
 * Get Case Report Template
 * Stream the case's report template .docx (MDRS-503).
 *
 * Replaces the ``report_template_url`` SAS that used to be embedded in every
 * case payload — including the *list*, which minted one 8h link per row on
 * every page load. Ownership is re-checked here on each fetch instead of once
 * at mint time, and there is no standalone URL left to forward or log.
 *
 * Serves the header-flattened *editor view*, not the raw upload: the eigenpal
 * docx-editor doesn't honour page-pinned anchors in ``word/header*.xml``
 * (upstream limitation, see ``utils/docx_header_preprocess.py``), so without
 * the flattening the Report Builder overlaps the body's own banner image. The
 * original blob at ``report_template_path`` is untouched and is what downloads
 * and PDF generation read.
 */
export const getCaseReportTemplateApiV1CasesCaseIdReportTemplateGet = <ThrowOnError extends boolean = false>(options: Options<GetCaseReportTemplateApiV1CasesCaseIdReportTemplateGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCaseReportTemplateApiV1CasesCaseIdReportTemplateGetResponses, GetCaseReportTemplateApiV1CasesCaseIdReportTemplateGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/{case_id}/report-template',
        ...options
    });
};

/**
 * Get Case By Case Number Endpoint
 */
export const getCaseByCaseNumberEndpointApiV1CasesGetCaseByCaseNumberCaseNumberGet = <ThrowOnError extends boolean = false>(options: Options<GetCaseByCaseNumberEndpointApiV1CasesGetCaseByCaseNumberCaseNumberGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCaseByCaseNumberEndpointApiV1CasesGetCaseByCaseNumberCaseNumberGetResponses, GetCaseByCaseNumberEndpointApiV1CasesGetCaseByCaseNumberCaseNumberGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/get-case-by-case-number/{case_number}',
        ...options
    });
};

/**
 * Export Case Endpoint
 */
export const exportCaseEndpointApiV1CasesCaseIdExportPost = <ThrowOnError extends boolean = false>(options: Options<ExportCaseEndpointApiV1CasesCaseIdExportPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExportCaseEndpointApiV1CasesCaseIdExportPostResponses, ExportCaseEndpointApiV1CasesCaseIdExportPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/{case_id}/export',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Check Exporting Files
 */
export const checkExportingFilesApiV1CasesCaseNumberCheckExportingFilesGet = <ThrowOnError extends boolean = false>(options: Options<CheckExportingFilesApiV1CasesCaseNumberCheckExportingFilesGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckExportingFilesApiV1CasesCaseNumberCheckExportingFilesGetResponses, CheckExportingFilesApiV1CasesCaseNumberCheckExportingFilesGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/{case_number}/check-exporting-files',
        ...options
    });
};

/**
 * Get Case Processing Status
 * Are the case's documents still being uploaded or summarised? (MDRS-508)
 *
 * Polled by Report Studio so the assigned doctor sees an admin's in-flight
 * upload and can't finalise until it settles (finalise enforces the same rule
 * server-side). Readable by anyone who can read the case.
 *
 * A plain ``def`` on purpose: it's polled from every open case view and its
 * queries are synchronous, so FastAPI runs it in the threadpool rather than
 * on the (single-worker) event loop.
 */
export const getCaseProcessingStatusApiV1CasesCaseNumberProcessingStatusGet = <ThrowOnError extends boolean = false>(options: Options<GetCaseProcessingStatusApiV1CasesCaseNumberProcessingStatusGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetCaseProcessingStatusApiV1CasesCaseNumberProcessingStatusGetResponses, GetCaseProcessingStatusApiV1CasesCaseNumberProcessingStatusGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/{case_number}/processing-status',
        ...options
    });
};

/**
 * Get Template Outline
 * Return the structural outline of the case's uploaded report template.
 *
 * Lazy-computed: on first request the .docx is fetched from Azure
 * Blob, parsed via `services.template_outline.extract_template_outline`,
 * and the result cached on `cases.report_template_outline`. Subsequent
 * requests hit the cache. The cache is invalidated automatically when
 * `report_template_path` changes (compared against the stored
 * `sourcePath` in the cached payload).
 *
 * Used by the Report Builder frontend to avoid re-running heading
 * detection heuristics on every report load — see
 * `services/template_outline.py` for the classification logic.
 */
export const getTemplateOutlineApiV1CasesGetCaseByCaseNumberCaseNumberTemplateOutlineGet = <ThrowOnError extends boolean = false>(options: Options<GetTemplateOutlineApiV1CasesGetCaseByCaseNumberCaseNumberTemplateOutlineGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTemplateOutlineApiV1CasesGetCaseByCaseNumberCaseNumberTemplateOutlineGetResponses, GetTemplateOutlineApiV1CasesGetCaseByCaseNumberCaseNumberTemplateOutlineGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/get-case-by-case-number/{case_number}/template-outline',
        ...options
    });
};

/**
 * Save Assessment
 */
export const saveAssessmentApiV1AssessmentPost = <ThrowOnError extends boolean = false>(options: Options<SaveAssessmentApiV1AssessmentPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveAssessmentApiV1AssessmentPostResponses, SaveAssessmentApiV1AssessmentPostErrors, ThrowOnError>({
        ...urlSearchParamsBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/assessment',
        ...options,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...options.headers
        }
    });
};

/**
 * Get Assessment By Case Number
 */
export const getAssessmentByCaseNumberApiV1AssessmentCaseCaseNumberGet = <ThrowOnError extends boolean = false>(options: Options<GetAssessmentByCaseNumberApiV1AssessmentCaseCaseNumberGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAssessmentByCaseNumberApiV1AssessmentCaseCaseNumberGetResponses, GetAssessmentByCaseNumberApiV1AssessmentCaseCaseNumberGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/assessment/case/{case_number}',
        ...options
    });
};

/**
 * Update Assessment
 */
export const updateAssessmentApiV1AssessmentAssessmentIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateAssessmentApiV1AssessmentAssessmentIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateAssessmentApiV1AssessmentAssessmentIdPatchResponses, UpdateAssessmentApiV1AssessmentAssessmentIdPatchErrors, ThrowOnError>({
        ...urlSearchParamsBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/assessment/{assessment_id}',
        ...options,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...options.headers
        }
    });
};

/**
 * Update Field Statuses
 * Update the status of specific fields in an assessment.
 * This endpoint allows updating the status of individual fields without changing their content.
 */
export const updateFieldStatusesApiV1AssessmentAssessmentIdFieldStatusPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateFieldStatusesApiV1AssessmentAssessmentIdFieldStatusPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateFieldStatusesApiV1AssessmentAssessmentIdFieldStatusPatchResponses, UpdateFieldStatusesApiV1AssessmentAssessmentIdFieldStatusPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/assessment/{assessment_id}/field-status',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Transcribe And Summarize Audio
 */
export const transcribeAndSummarizeAudioApiV1TranscriptionSummarizePost = <ThrowOnError extends boolean = false>(options?: Options<TranscribeAndSummarizeAudioApiV1TranscriptionSummarizePostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<TranscribeAndSummarizeAudioApiV1TranscriptionSummarizePostResponses, TranscribeAndSummarizeAudioApiV1TranscriptionSummarizePostErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/transcription/summarize',
        ...options,
        headers: {
            'Content-Type': null,
            ...options?.headers
        }
    });
};

/**
 * Retry Transcription Summary
 * Re-run the case's transcription from its stored recording (MDRS-575).
 *
 * ``/summarize`` stores the audio before the job starts and deletes it once the
 * transcription succeeds, so a stored copy means "not transcribed yet" — even if
 * the doctor has since edited notes (status EDITED). It stays until the retry
 * succeeds.
 *
 * Re-sends the saved speaker hints. An upload's expected speaker count and
 * second language aren't stored, so a retry falls back to auto-detecting them.
 */
export const retryTranscriptionSummaryApiV1TranscriptionSummarizeRetryPost = <ThrowOnError extends boolean = false>(options: Options<RetryTranscriptionSummaryApiV1TranscriptionSummarizeRetryPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetryTranscriptionSummaryApiV1TranscriptionSummarizeRetryPostResponses, RetryTranscriptionSummaryApiV1TranscriptionSummarizeRetryPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/transcription/summarize/retry',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Transcription Summary Status
 */
export const getTranscriptionSummaryStatusApiV1TranscriptionSummaryStatusTaskIdGet = <ThrowOnError extends boolean = false>(options: Options<GetTranscriptionSummaryStatusApiV1TranscriptionSummaryStatusTaskIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTranscriptionSummaryStatusApiV1TranscriptionSummaryStatusTaskIdGetResponses, GetTranscriptionSummaryStatusApiV1TranscriptionSummaryStatusTaskIdGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/transcription/summary/status/{task_id}',
        ...options
    });
};

/**
 * Query Transcript
 * Query transcripts in Cosmos database for a specific case.
 *
 * This endpoint sends a natural language query to the Cosmos API to search
 * specifically within transcript documents for the given case.
 */
export const queryTranscriptApiV1TranscriptionQueryTranscriptPost = <ThrowOnError extends boolean = false>(options: Options<QueryTranscriptApiV1TranscriptionQueryTranscriptPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QueryTranscriptApiV1TranscriptionQueryTranscriptPostResponses, QueryTranscriptApiV1TranscriptionQueryTranscriptPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/transcription/query-transcript',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Confirm Assessment Scribe recording consent for a case
 * Record that the authenticated user confirmed examinee consent before
 * starting a live recording session for `case_number` (SCRIBE-02). Called by
 * the frontend the instant the consent checkbox is confirmed, before it
 * requests a streaming token. Grants a short, sliding-window consent that the
 * token endpoints below check and extend on each successful call.
 */
export const confirmRecordingConsentApiV1TranscriptionConsentPost = <ThrowOnError extends boolean = false>(options: Options<ConfirmRecordingConsentApiV1TranscriptionConsentPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ConfirmRecordingConsentApiV1TranscriptionConsentPostResponses, ConfirmRecordingConsentApiV1TranscriptionConsentPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/transcription/consent',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a temporary AssemblyAI streaming token
 * Generate a short-lived temporary authentication token for AssemblyAI
 * real-time streaming. The frontend uses this token to open a direct
 * WebSocket to AssemblyAI -- no audio flows through this backend.
 *
 * AssemblyAI is only used by Assessment Scribe, so `case_number` is required
 * and case ownership + an active recording consent are checked (SCRIBE-02,
 * MDRS-560).
 */
export const getStreamingTokenApiV1TranscriptionStreamingTokenPost = <ThrowOnError extends boolean = false>(options: Options<GetStreamingTokenApiV1TranscriptionStreamingTokenPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetStreamingTokenApiV1TranscriptionStreamingTokenPostResponses, GetStreamingTokenApiV1TranscriptionStreamingTokenPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/transcription/streaming-token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get a temporary Azure Speech authorization token
 * Generate a short-lived (~10 min) authorization token for Azure AI Speech
 * real-time transcription. The frontend uses this token, together with the
 * region, to open a direct connection to Azure Speech via the browser SDK
 * -- no audio flows through this backend.
 *
 * `purpose="scribe"` records a case's assessment: `case_number` is required
 * and case ownership + an active recording consent are checked (SCRIBE-02).
 * `purpose="dictation"` is solo report dictation: no case, no consent check.
 * Both are rate-limited per user (MDRS-560).
 */
export const getAzureSpeechTokenApiV1TranscriptionAzureSpeechTokenPost = <ThrowOnError extends boolean = false>(options: Options<GetAzureSpeechTokenApiV1TranscriptionAzureSpeechTokenPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetAzureSpeechTokenApiV1TranscriptionAzureSpeechTokenPostResponses, GetAzureSpeechTokenApiV1TranscriptionAzureSpeechTokenPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/transcription/azure-speech-token',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Query Cosmos
 * Query the Cosmos database for information related to a case.
 *
 * This endpoint sends a natural language query to the Cosmos API and returns
 * an AI-generated answer along with supporting documents.
 */
export const queryCosmosApiV1CosmosQueryPost = <ThrowOnError extends boolean = false>(options: Options<QueryCosmosApiV1CosmosQueryPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<QueryCosmosApiV1CosmosQueryPostResponses, QueryCosmosApiV1CosmosQueryPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cosmos/query',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Quick Lookups
 * The enabled Quick Lookups and the pack's boundary line.
 *
 * Proxied from the cosmos-service register so the frontend never keeps its own
 * copy of the wording. Disabled lookups are not in the list. The register holds
 * no case data, so only the signed-in check applies here.
 */
export const listQuickLookupsApiV1CosmosQuickLookupsGet = <ThrowOnError extends boolean = false>(options?: Options<ListQuickLookupsApiV1CosmosQuickLookupsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListQuickLookupsApiV1CosmosQuickLookupsGetResponses, ListQuickLookupsApiV1CosmosQuickLookupsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cosmos/quick-lookups',
        ...options
    });
};

/**
 * Get Response Draft Docx
 * Stream the WIP draft .docx the Report Builder editor loads (MDRS-503).
 *
 * Replaces the ``draft_docx_download_url`` SAS that used to ride along in the
 * draft-status and response payloads. The draft is the report in progress, so
 * it is PHI; ownership is re-checked here on every fetch.
 *
 * Scoped through the case — the doctor it is currently assigned to, or an
 * admin (MDRS-567). The same shape as ``preview_response_as_pdf``.
 *
 * Serves the header-flattened *editor view* (see ``cache_editor_view``): the
 * docx-editor doesn't honour page-pinned anchors in ``word/header*.xml``, so
 * the raw blob would overlap the body content. Downloads and PDF generation
 * keep reading the original.
 */
export const getResponseDraftDocxApiV1ReportGeneratorResponsesResponseIdDraftDocxGet = <ThrowOnError extends boolean = false>(options: Options<GetResponseDraftDocxApiV1ReportGeneratorResponsesResponseIdDraftDocxGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResponseDraftDocxApiV1ReportGeneratorResponsesResponseIdDraftDocxGetResponses, GetResponseDraftDocxApiV1ReportGeneratorResponsesResponseIdDraftDocxGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/responses/{response_id}/draft-docx',
        ...options
    });
};

/**
 * Get All Exported Cases
 */
export const getAllExportedCasesApiV1ReportGeneratorExportedCasesGet = <ThrowOnError extends boolean = false>(options?: Options<GetAllExportedCasesApiV1ReportGeneratorExportedCasesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllExportedCasesApiV1ReportGeneratorExportedCasesGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/exported-cases',
        ...options
    });
};

/**
 * Get All Exported Files
 */
export const getAllExportedFilesApiV1ReportGeneratorExportedCasesCaseIdFilesGet = <ThrowOnError extends boolean = false>(options: Options<GetAllExportedFilesApiV1ReportGeneratorExportedCasesCaseIdFilesGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetAllExportedFilesApiV1ReportGeneratorExportedCasesCaseIdFilesGetResponses, GetAllExportedFilesApiV1ReportGeneratorExportedCasesCaseIdFilesGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/exported-cases/{case_id}/files',
        ...options
    });
};

/**
 * Delete Exported File
 */
export const deleteExportedFileApiV1ReportGeneratorExportedFileIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteExportedFileApiV1ReportGeneratorExportedFileIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteExportedFileApiV1ReportGeneratorExportedFileIdDeleteResponses, DeleteExportedFileApiV1ReportGeneratorExportedFileIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/exported-file/{id}',
        ...options
    });
};

/**
 * Get Code Of Conduct Entries
 * Return all Code of Conduct reference declarations, in display order.
 *
 * Read-only reference content for the Report Builder CoC panel (MDRS-139).
 * The full set is small (~30 rows) so we return everything and let the
 * client filter by jurisdiction; the panel already does the multi-select
 * union locally.
 */
export const getCodeOfConductEntriesApiV1ReportGeneratorCodeOfConductGet = <ThrowOnError extends boolean = false>(options?: Options<GetCodeOfConductEntriesApiV1ReportGeneratorCodeOfConductGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCodeOfConductEntriesApiV1ReportGeneratorCodeOfConductGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/code-of-conduct',
        ...options
    });
};

/**
 * Get All Templates
 * Get all templates available to the user with pagination and search support.
 *
 * Returns templates with sections and modules, plus a template_type field indicating
 * whether each template is "system" or "custom".
 *
 * Args:
 * template_type: Optional filter - "system" for system templates, "custom" for custom templates, or None for both
 * search: Optional search term to filter templates by name (case-insensitive)
 * sort_by: Field to sort by - "created_at" or "order" (default: "created_at")
 * sort_order: Sort direction - "asc" or "desc" (default: "desc")
 * page: Page number (starts from 1, validated by get_pagination_params)
 * limit: Number of items per page (max 100, validated by get_pagination_params)
 */
export const getAllTemplatesApiV1ReportGeneratorTemplatesGet = <ThrowOnError extends boolean = false>(options?: Options<GetAllTemplatesApiV1ReportGeneratorTemplatesGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetAllTemplatesApiV1ReportGeneratorTemplatesGetResponses, GetAllTemplatesApiV1ReportGeneratorTemplatesGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates',
        ...options
    });
};

/**
 * Create Template
 */
export const createTemplateApiV1ReportGeneratorTemplatesPost = <ThrowOnError extends boolean = false>(options: Options<CreateTemplateApiV1ReportGeneratorTemplatesPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateTemplateApiV1ReportGeneratorTemplatesPostResponses, CreateTemplateApiV1ReportGeneratorTemplatesPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Template
 * Delete a custom template.
 *
 * Users can only delete their own custom templates.
 * TODO: Add admin role check to allow admins to delete any template when role system is implemented.
 */
export const deleteTemplateApiV1ReportGeneratorTemplatesIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteTemplateApiV1ReportGeneratorTemplatesIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteTemplateApiV1ReportGeneratorTemplatesIdDeleteResponses, DeleteTemplateApiV1ReportGeneratorTemplatesIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}',
        ...options
    });
};

/**
 * Get Template
 */
export const getTemplateApiV1ReportGeneratorTemplatesIdGet = <ThrowOnError extends boolean = false>(options: Options<GetTemplateApiV1ReportGeneratorTemplatesIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTemplateApiV1ReportGeneratorTemplatesIdGetResponses, GetTemplateApiV1ReportGeneratorTemplatesIdGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}',
        ...options
    });
};

/**
 * Update Template
 */
export const updateTemplateApiV1ReportGeneratorTemplatesIdPut = <ThrowOnError extends boolean = false>(options: Options<UpdateTemplateApiV1ReportGeneratorTemplatesIdPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UpdateTemplateApiV1ReportGeneratorTemplatesIdPutResponses, UpdateTemplateApiV1ReportGeneratorTemplatesIdPutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Template Raw Docx
 * Stream the template's source .docx bytes (MDRS-503).
 *
 * Replaces ``/templates/{id}/raw-docx-url``, which minted a SAS the browser
 * then fetched straight from Azure. Serving the bytes here keeps
 * ``get_readable_template_or_404`` in the path on **every** fetch rather than
 * only at mint time, and leaves no standalone URL to leak.
 *
 * Used by the client-side docx-editor integration to load the raw template in
 * the browser (no HTML conversion). Falls back to the base template's blob if
 * a derived template inherits it.
 */
export const getTemplateRawDocxApiV1ReportGeneratorTemplatesIdRawDocxGet = <ThrowOnError extends boolean = false>(options: Options<GetTemplateRawDocxApiV1ReportGeneratorTemplatesIdRawDocxGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTemplateRawDocxApiV1ReportGeneratorTemplatesIdRawDocxGetResponses, GetTemplateRawDocxApiV1ReportGeneratorTemplatesIdRawDocxGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/raw-docx',
        ...options
    });
};

/**
 * Get User Initial Answers
 */
export const getUserInitialAnswersApiV1ReportGeneratorTemplatesIdCasesCaseNumberGetUserInitialAnswersPost = <ThrowOnError extends boolean = false>(options: Options<GetUserInitialAnswersApiV1ReportGeneratorTemplatesIdCasesCaseNumberGetUserInitialAnswersPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetUserInitialAnswersApiV1ReportGeneratorTemplatesIdCasesCaseNumberGetUserInitialAnswersPostResponses, GetUserInitialAnswersApiV1ReportGeneratorTemplatesIdCasesCaseNumberGetUserInitialAnswersPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/get-user-initial-answers',
        ...options
    });
};

/**
 * Regenerate
 */
export const regenerateApiV1ReportGeneratorTemplatesIdCasesCaseNumberRegeneratePost = <ThrowOnError extends boolean = false>(options: Options<RegenerateApiV1ReportGeneratorTemplatesIdCasesCaseNumberRegeneratePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RegenerateApiV1ReportGeneratorTemplatesIdCasesCaseNumberRegeneratePostResponses, RegenerateApiV1ReportGeneratorTemplatesIdCasesCaseNumberRegeneratePostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/regenerate',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Synthesize
 */
export const synthesizeApiV1ReportGeneratorTemplatesIdCasesCaseNumberSynthesizePost = <ThrowOnError extends boolean = false>(options: Options<SynthesizeApiV1ReportGeneratorTemplatesIdCasesCaseNumberSynthesizePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SynthesizeApiV1ReportGeneratorTemplatesIdCasesCaseNumberSynthesizePostResponses, SynthesizeApiV1ReportGeneratorTemplatesIdCasesCaseNumberSynthesizePostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/synthesize',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Answer Questions
 */
export const answerQuestionsApiV1ReportGeneratorTemplatesIdCasesCaseNumberAnswerQuestionsPost = <ThrowOnError extends boolean = false>(options: Options<AnswerQuestionsApiV1ReportGeneratorTemplatesIdCasesCaseNumberAnswerQuestionsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AnswerQuestionsApiV1ReportGeneratorTemplatesIdCasesCaseNumberAnswerQuestionsPostResponses, AnswerQuestionsApiV1ReportGeneratorTemplatesIdCasesCaseNumberAnswerQuestionsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/answer-questions',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Save Draft
 * Save a report draft based on the provided template and case.
 *
 * Request body follows GenerateReportRequestSchema format with module_name dictionary
 * containing module data with fields for value, summaries, and responses.
 *
 * ``expected_version`` is the optimistic-concurrency token (MDRS-554). When
 * supplied and no longer current, the save is refused with a 409 and NOTHING
 * is written by THIS request — a partial save would leave the draft in a
 * state neither editor authored. Omitting it keeps the previous
 * unconditional behaviour, which is what the non-editor callers and any
 * pre-MDRS-554 client rely on.
 *
 * Scope of the guarantee, stated honestly: the editor's save is two requests
 * (this one, then ``upload_draft_docx``) and each takes its own version, so a
 * competing save landing between them can leave the module payload committed
 * without its matching body. Both halves are individually protected and
 * neither can overwrite a newer write; what is not atomic is the PAIR.
 * Closing that needs a single request carrying both payloads — deliberately
 * out of scope here, and the window is one network round trip wide.
 */
export const saveDraftApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveDraftPost = <ThrowOnError extends boolean = false>(options: Options<SaveDraftApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveDraftPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveDraftApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveDraftPostResponses, SaveDraftApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveDraftPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/save-draft',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Check Draft Status
 * Check if there's a current draft for the specified template and case.
 * Checks the latest status from ReportGeneratorTemplateResponseStatus model.
 */
export const checkDraftStatusApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftStatusGet = <ThrowOnError extends boolean = false>(options: Options<CheckDraftStatusApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftStatusGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<CheckDraftStatusApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftStatusGetResponses, CheckDraftStatusApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftStatusGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/draft-status',
        ...options
    });
};

/**
 * Get Draft Report
 * Retrieve the draft report for the specified template and case.
 *
 * Returns the draft report data including all modules and the generated report URL if available.
 * Raises 404 if no draft exists.
 */
export const getDraftReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftReportGet = <ThrowOnError extends boolean = false>(options: Options<GetDraftReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftReportGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetDraftReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftReportGetResponses, GetDraftReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftReportGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/draft-report',
        ...options
    });
};

/**
 * Complete Response
 * Mark a draft response as COMPLETED to allow starting fresh.
 *
 * This endpoint is used when a user wants to start a new draft, effectively
 * closing the existing draft. The response row and its status history are
 * both moved to COMPLETED.
 *
 * MDRS-572: the response row itself used to be left on DRAFT, so "completing"
 * a draft closed it only in the history table while every draft lookup — all
 * of which filter on `response.status` — still resolved to it. Under the
 * one-draft-per-(case, user) index that is worse than cosmetic: the
 * start-fresh insert would collide with the row it was superseding.
 */
export const completeResponseApiV1ReportGeneratorResponsesResponseIdCompletePut = <ThrowOnError extends boolean = false>(options: Options<CompleteResponseApiV1ReportGeneratorResponsesResponseIdCompletePutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<CompleteResponseApiV1ReportGeneratorResponsesResponseIdCompletePutResponses, CompleteResponseApiV1ReportGeneratorResponsesResponseIdCompletePutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/responses/{response_id}/complete',
        ...options
    });
};

/**
 * Claim Report Editor Lease
 * Claim or renew the advisory single-editor lease (MDRS-554 / audit RB-8).
 *
 * Called on mount and then on a heartbeat while the editor is open. Losing
 * the claim is a normal outcome, not an error: the response names the holder
 * so the second tab can render its read-only banner. Returning a 409 here
 * would leave that banner with nothing to say and would make an ordinary
 * second visit look like a failure.
 *
 * Resolved with ``write=False`` on purpose. ``write=True`` would apply the
 * finalise lock (see :func:`get_response_for_user`), so every 30s heartbeat
 * on a finalised case would 409 and "Take over editing" would report a
 * failure — removing the banner exactly when two people are most likely to
 * be looking at the same frozen report. The lease is coordination state, not
 * report content; the write lock that matters is still enforced on the save
 * paths, and the client refuses to edit a finalised case regardless
 * (``canEditWithLease``).
 *
 * Row scope is unchanged: ``get_response_for_user`` is owner-or-admin even
 * for reads (MDRS-567).
 */
export const claimReportEditorLeaseApiV1ReportGeneratorResponsesResponseIdEditorLeasePost = <ThrowOnError extends boolean = false>(options: Options<ClaimReportEditorLeaseApiV1ReportGeneratorResponsesResponseIdEditorLeasePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ClaimReportEditorLeaseApiV1ReportGeneratorResponsesResponseIdEditorLeasePostResponses, ClaimReportEditorLeaseApiV1ReportGeneratorResponsesResponseIdEditorLeasePostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/responses/{response_id}/editor-lease',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Response By Id
 * Retrieve a report response by its ID.
 *
 * Returns the report response data including all modules and the generated report URL if available.
 * Raises 404 if the response doesn't exist or the caller is neither the
 * doctor its case is assigned to nor an admin (MDRS-567). Owner-or-admin
 * rather than owner-only, per MDRS-304's admin co-edit.
 */
export const getResponseByIdApiV1ReportGeneratorResponsesResponseIdGet = <ThrowOnError extends boolean = false>(options: Options<GetResponseByIdApiV1ReportGeneratorResponsesResponseIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetResponseByIdApiV1ReportGeneratorResponsesResponseIdGetResponses, GetResponseByIdApiV1ReportGeneratorResponsesResponseIdGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/responses/{response_id}',
        ...options
    });
};

/**
 * Upload Draft Docx
 * Persist the editor's current .docx as a WIP draft.
 *
 * Called by the SplitDocx auto-save tick after the user edits the
 * report on the right pane. The blob is stored at a stable per-
 * response path so each new save overwrites the previous one — we
 * don't keep a history. The DRAFT response is created on first save
 * if it doesn't exist yet (same pattern as `save_draft`).
 *
 * ``expected_version`` carries the same optimistic-concurrency token as
 * `save_draft` (MDRS-554 / audit RB-8). This is where the data loss actually
 * bit — the .docx IS the report — so the check runs before the blob is
 * written and before ``draft_docx_url`` is repointed.
 */
export const uploadDraftDocxApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftDocxPut = <ThrowOnError extends boolean = false>(options: Options<UploadDraftDocxApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftDocxPutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<UploadDraftDocxApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftDocxPutResponses, UploadDraftDocxApiV1ReportGeneratorTemplatesIdCasesCaseNumberDraftDocxPutErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/draft-docx',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Get Source Snippets
 * Per-section / per-module source content for the middle column.
 *
 * Returns the individual `extract_sources` (one snippet card per
 * row) plus the legacy merged `summary_from_doc_sorter` and
 * `summary_from_assessment_scribe` blobs as optional whole-paragraph
 * "Summary from X" cards. Both shapes are supported so the UI can
 * render snippet cards AND a select-all-summary card per category.
 *
 * Returns an empty list when no draft response exists yet for the
 * (case, user) pair — the middle column simply renders no source
 * content until a save creates the response row.
 */
export const getSourceSnippetsApiV1ReportGeneratorTemplatesIdCasesCaseNumberSourceSnippetsGet = <ThrowOnError extends boolean = false>(options: Options<GetSourceSnippetsApiV1ReportGeneratorTemplatesIdCasesCaseNumberSourceSnippetsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetSourceSnippetsApiV1ReportGeneratorTemplatesIdCasesCaseNumberSourceSnippetsGetResponses, GetSourceSnippetsApiV1ReportGeneratorTemplatesIdCasesCaseNumberSourceSnippetsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/source-snippets',
        ...options
    });
};

/**
 * Generate Report
 * Generate a report based on the provided template and case.
 *
 * Request body follows GenerateReportRequestSchema format with module_name dictionary
 * containing module data with fields for value, summaries, and responses.
 */
export const generateReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateReportPost = <ThrowOnError extends boolean = false>(options: Options<GenerateReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateReportPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GenerateReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateReportPostResponses, GenerateReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateReportPostErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/generate-report',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Save Report
 * Save the updated report file (keeps status as DRAFT).
 *
 * This endpoint accepts an updated file from the frontend editor, uploads it to blob storage,
 * and updates the ReportGeneratorTemplateResponse generated_report_url.
 * Status remains DRAFT until explicitly marked as COMPLETED via complete_response endpoint.
 */
export const saveReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveReportPost = <ThrowOnError extends boolean = false>(options: Options<SaveReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveReportPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveReportPostResponses, SaveReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberSaveReportPostErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/save-report',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Preview Report
 * Preview a report based on the provided template and case.
 *
 * Request body follows GenerateReportRequestSchema format with module_name dictionary
 * containing module data with fields for value, summaries, and responses.
 */
export const previewReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberPreviewReportPost = <ThrowOnError extends boolean = false>(options: Options<PreviewReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberPreviewReportPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreviewReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberPreviewReportPostResponses, PreviewReportApiV1ReportGeneratorTemplatesIdCasesCaseNumberPreviewReportPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/preview-report',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Generate From Html
 * Generate a DOCX from the Review-and-Download page's edited HTML. The
 * editor renders the template with `<span data-ph="X">{{X}}</span>` markers
 * around each placeholder; this endpoint reads those marks back to build a
 * placeholder substitution map, then splices the user's body edits between
 * the template's Thank-You and Yours-Sincerely anchors. The DOCX template
 * is preserved as-is — only placeholder values + body content are taken
 * from the editor.
 */
export const generateFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateFromHtmlPost = <ThrowOnError extends boolean = false>(options: Options<GenerateFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateFromHtmlPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GenerateFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateFromHtmlPostResponses, GenerateFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGenerateFromHtmlPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/generate-from-html',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Download Response As Pdf
 * Admin-only PDF download (MDRS-271). The doctor no longer downloads — they
 * finalise — so this endpoint is gated to admins server-side (403 for doctors,
 * regardless of conditional rendering in the UI), and is the chain-of-custody
 * step for the manual Vinci upload.
 *
 * For a **finalised** report it serves the *frozen* ``finalised_pdf_uri``
 * artifact verbatim — byte-identical to what the doctor signed off on, never a
 * fresh render. For a not-yet-finalised report it renders on demand (admin
 * preview). Every admin download is audit-logged.
 *
 * POST (not GET) so the optional ``password`` lives in the JSON body and
 * never lands in access logs, browser history, or proxy caches.
 */
export const downloadResponseAsPdfApiV1ReportGeneratorResponsesResponseIdDownloadPdfPost = <ThrowOnError extends boolean = false>(options: Options<DownloadResponseAsPdfApiV1ReportGeneratorResponsesResponseIdDownloadPdfPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<DownloadResponseAsPdfApiV1ReportGeneratorResponsesResponseIdDownloadPdfPostResponses, DownloadResponseAsPdfApiV1ReportGeneratorResponsesResponseIdDownloadPdfPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/responses/{response_id}/download-pdf',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Preview Response As Pdf
 * Owner-or-admin PDF preview for the Report Builder "Preview" step.
 *
 * Unlike ``download-pdf`` this is not gated to admins — doctors keep a way to
 * check formatting before the one-way Finalise lock (MDRS-271 gated
 * download-pdf to admins but doctors still need to see the report before
 * finalising). It renders the same bytes ``download-pdf`` would, so it is
 * audit-logged too (``REPORT_PREVIEWED``, distinct from
 * ``REPORT_DOWNLOADED_ADMIN``) even though it isn't restricted to admins —
 * MDRS-299. No password support — encryption is for the exported artifact,
 * not an on-screen render.
 *
 * Scoped through the case (MDRS-567): the doctor it is currently assigned to,
 * or an admin — the same owner-or-admin shape as ``check_draft_status``.
 */
export const previewResponseAsPdfApiV1ReportGeneratorResponsesResponseIdPreviewPdfPost = <ThrowOnError extends boolean = false>(options: Options<PreviewResponseAsPdfApiV1ReportGeneratorResponsesResponseIdPreviewPdfPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<PreviewResponseAsPdfApiV1ReportGeneratorResponsesResponseIdPreviewPdfPostResponses, PreviewResponseAsPdfApiV1ReportGeneratorResponsesResponseIdPreviewPdfPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/responses/{response_id}/preview-pdf',
        ...options
    });
};

/**
 * Download Response As Docx
 * Stream the merged WIP draft .docx back to the caller.
 *
 * Owner-or-admin, capability-gated (MDRS-336). MDRS-271 had made this
 * admin-only along with the PDF, closing every doctor export path; MDRS-336
 * reopens the Word download alone. It goes back to the
 * REPORT_DOWNLOAD_DOCX capability (MDRS-162) rather than a hardcoded role
 * check, so it stays togglable per user type in the access-configuration pane.
 * The PDF endpoint stays admin-only — the frozen ``finalised_pdf_uri`` remains
 * the chain-of-custody artifact for the Vinci upload.
 *
 * Scoped through the case (MDRS-567): the doctor it is currently assigned to,
 * or an admin — the same shape as ``preview_response_as_pdf``.
 *
 * Available on finalised (locked) cases too. The finalise lock is a *write*
 * lock — this is a read, so there is deliberately no ``assert_case_writable``
 * call. Note the .docx is a re-render of the stored draft, not the frozen PDF
 * the doctor signed off on; the case being locked is what keeps the content
 * equivalent.
 *
 * The frontend editor's own Download button calls editor.save() in the
 * browser, which strips header/footer media (the @eigenpal/docx-editor
 * parser doesn't traverse anchored textboxes). That makes the locally
 * downloaded .docx header-less even though the version persisted on
 * blob storage — which we merge against the original template on every
 * save in `upload_draft_docx` — has the letterhead intact. This
 * endpoint returns that server-merged blob so the user gets the same
 * fidelity .docx they'd get if they converted to PDF and back.
 *
 * Falls back to ``generated_report_url`` (already-finalised reports) so
 * the same button works on both autosave drafts and explicit generations.
 */
export const downloadResponseAsDocxApiV1ReportGeneratorResponsesResponseIdDownloadDocxGet = <ThrowOnError extends boolean = false>(options: Options<DownloadResponseAsDocxApiV1ReportGeneratorResponsesResponseIdDownloadDocxGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<DownloadResponseAsDocxApiV1ReportGeneratorResponsesResponseIdDownloadDocxGetResponses, DownloadResponseAsDocxApiV1ReportGeneratorResponsesResponseIdDownloadDocxGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/responses/{response_id}/download-docx',
        ...options
    });
};

/**
 * Generate Pdf From Html
 * Generate a PDF from the Review-and-Download page's edited HTML, optionally
 * AES-256 encrypted with ``password``. The DOCX is built exactly as in
 * ``generate-from-html`` (and remains the source of truth in blob storage);
 * the PDF is converted on-demand, streamed back, and not persisted.
 *
 * POST (not GET) so the optional ``password`` lives in the JSON body and never
 * lands in access logs, browser history, or proxy caches.
 */
export const generatePdfFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGeneratePdfFromHtmlPost = <ThrowOnError extends boolean = false>(options: Options<GeneratePdfFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGeneratePdfFromHtmlPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GeneratePdfFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGeneratePdfFromHtmlPostResponses, GeneratePdfFromHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberGeneratePdfFromHtmlPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/generate-pdf-from-html',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Render Template Html
 * Convert the case's template DOCX into HTML for the Tiptap-based Review
 * page. Group A placeholders (doctor / client / date_of_examination) are
 * auto-filled before conversion. Optionally splices accepted section content
 * (`body_html`) between the Thank-You and Yours-Sincerely anchors.
 */
export const renderTemplateHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberRenderHtmlPost = <ThrowOnError extends boolean = false>(options: Options<RenderTemplateHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberRenderHtmlPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RenderTemplateHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberRenderHtmlPostResponses, RenderTemplateHtmlApiV1ReportGeneratorTemplatesIdCasesCaseNumberRenderHtmlPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/render-html',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Generated Reports
 */
export const getGeneratedReportsApiV1ReportGeneratorCasesCaseNumberGeneratedReportsGet = <ThrowOnError extends boolean = false>(options: Options<GetGeneratedReportsApiV1ReportGeneratorCasesCaseNumberGeneratedReportsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetGeneratedReportsApiV1ReportGeneratorCasesCaseNumberGeneratedReportsGetResponses, GetGeneratedReportsApiV1ReportGeneratorCasesCaseNumberGeneratedReportsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/cases/{case_number}/generated-reports',
        ...options
    });
};

/**
 * Refine Experts Commentary
 * Refine experts commentary by calling the Azure AI Utils function.
 */
export const refineExpertsCommentaryApiV1ReportGeneratorRefineExpertsCommentaryPost = <ThrowOnError extends boolean = false>(options: Options<RefineExpertsCommentaryApiV1ReportGeneratorRefineExpertsCommentaryPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RefineExpertsCommentaryApiV1ReportGeneratorRefineExpertsCommentaryPostResponses, RefineExpertsCommentaryApiV1ReportGeneratorRefineExpertsCommentaryPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/refine-experts-commentary',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Run Report Qa Route
 * Run a new Report QA pass against the user's WIP draft .docx.
 *
 * Always re-runs against the latest `draft_docx_url` on the response
 * (no caching/dedup). Each call persists a fresh row in
 * `report_qa_result`, building a history the UI can replay later.
 */
export const runReportQaRouteApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaPost = <ThrowOnError extends boolean = false>(options: Options<RunReportQaRouteApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RunReportQaRouteApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaPostResponses, RunReportQaRouteApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/report-qa',
        ...options
    });
};

/**
 * Get Latest Report Qa
 * Return the most recent QA pass for the user's draft, or null.
 *
 * Cheap fetch — no LLM call. Used by the editor to re-display the
 * last critique on page load without re-running QA. Returns null
 * when no draft response exists yet or no QA has been run, so the
 * UI can render an empty state without branching on 404s.
 */
export const getLatestReportQaApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaLatestGet = <ThrowOnError extends boolean = false>(options: Options<GetLatestReportQaApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaLatestGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetLatestReportQaApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaLatestGetResponses, GetLatestReportQaApiV1ReportGeneratorTemplatesIdCasesCaseNumberReportQaLatestGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/templates/{id}/cases/{case_number}/report-qa/latest',
        ...options
    });
};

/**
 * List Module Extracts
 * List all extract sources for a case.
 */
export const listModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsGet = <ThrowOnError extends boolean = false>(options: Options<ListModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsGetResponses, ListModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/cases/{case_number}/module-extracts',
        ...options
    });
};

/**
 * Map Extract To Modules
 * Map extracted text to one or more report builder modules.
 */
export const mapExtractToModulesApiV1ReportGeneratorCasesCaseNumberModuleExtractsPost = <ThrowOnError extends boolean = false>(options: Options<MapExtractToModulesApiV1ReportGeneratorCasesCaseNumberModuleExtractsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MapExtractToModulesApiV1ReportGeneratorCasesCaseNumberModuleExtractsPostResponses, MapExtractToModulesApiV1ReportGeneratorCasesCaseNumberModuleExtractsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/cases/{case_number}/module-extracts',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Reorder Module Extracts
 * Persist the All-Notes drag order across the whole report (MDRS-8).
 *
 * ``order`` is scoped per (module, target_field) and drives the per-section
 * list; this writes ``global_order`` — the flat cross-module position used
 * by the Report Builder "All Notes" view — to each extract by its index in
 * ``ordered_ids``.
 */
export const reorderModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsOrderPatch = <ThrowOnError extends boolean = false>(options: Options<ReorderModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsOrderPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<ReorderModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsOrderPatchResponses, ReorderModuleExtractsApiV1ReportGeneratorCasesCaseNumberModuleExtractsOrderPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/cases/{case_number}/module-extracts/order',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Module Extract
 * Delete a single extract source.
 *
 * STP-93: the textbox column is now user-owned content (append-only on map),
 * so deleting an extract row no longer rebuilds the column — that would
 * wipe manual edits.
 */
export const deleteModuleExtractApiV1ReportGeneratorModuleExtractsExtractIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteModuleExtractApiV1ReportGeneratorModuleExtractsExtractIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteModuleExtractApiV1ReportGeneratorModuleExtractsExtractIdDeleteResponses, DeleteModuleExtractApiV1ReportGeneratorModuleExtractsExtractIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/module-extracts/{extract_id}',
        ...options
    });
};

/**
 * Retry Auto Map Loi
 * Re-run LOI auto-mapping for the case.
 *
 * The orchestrator makes blocking httpx calls to the extractor function
 * per LOI file, so the work is dispatched to a worker thread to avoid
 * blocking the FastAPI event loop. Uses a fresh DB session inside the
 * thread to avoid sharing the request-scoped session across threads.
 */
export const retryAutoMapLoiApiV1ReportGeneratorCasesCaseNumberAutoMapLoiPost = <ThrowOnError extends boolean = false>(options: Options<RetryAutoMapLoiApiV1ReportGeneratorCasesCaseNumberAutoMapLoiPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RetryAutoMapLoiApiV1ReportGeneratorCasesCaseNumberAutoMapLoiPostResponses, RetryAutoMapLoiApiV1ReportGeneratorCasesCaseNumberAutoMapLoiPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/cases/{case_number}/auto-map-loi',
        ...options
    });
};

/**
 * Finalise Response
 * Doctor finalises their report — locks the case, freezes the PDF for Vinci.
 *
 * Owner-scoped on the **case** (MDRS-567): only the doctor the case is
 * currently assigned to can finalise it, and ``owner_only`` excludes admins —
 * finalising records that doctor's personal attestation, so an admin must not
 * sign on their behalf. The lock itself stays admin-reversible via ``/unlock``.
 */
export const finaliseResponseApiV1ReportGeneratorResponsesResponseIdFinalisePost = <ThrowOnError extends boolean = false>(options: Options<FinaliseResponseApiV1ReportGeneratorResponsesResponseIdFinalisePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<FinaliseResponseApiV1ReportGeneratorResponsesResponseIdFinalisePostResponses, FinaliseResponseApiV1ReportGeneratorResponsesResponseIdFinalisePostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/responses/{response_id}/finalise',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Unlock Response
 * Admin break-glass unlock (not surfaced in the doctor UI). Reason mandatory,
 * audit-logged. Resolves the response by id across any owner.
 */
export const unlockResponseApiV1ReportGeneratorResponsesResponseIdUnlockPost = <ThrowOnError extends boolean = false>(options: Options<UnlockResponseApiV1ReportGeneratorResponsesResponseIdUnlockPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<UnlockResponseApiV1ReportGeneratorResponsesResponseIdUnlockPostResponses, UnlockResponseApiV1ReportGeneratorResponsesResponseIdUnlockPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/responses/{response_id}/unlock',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Mark Response Vinci Uploaded
 * Admin marks the frozen PDF as uploaded to Vinci (interim manual transport).
 */
export const markResponseVinciUploadedApiV1ReportGeneratorResponsesResponseIdMarkVinciUploadedPost = <ThrowOnError extends boolean = false>(options: Options<MarkResponseVinciUploadedApiV1ReportGeneratorResponsesResponseIdMarkVinciUploadedPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<MarkResponseVinciUploadedApiV1ReportGeneratorResponsesResponseIdMarkVinciUploadedPostResponses, MarkResponseVinciUploadedApiV1ReportGeneratorResponsesResponseIdMarkVinciUploadedPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/responses/{response_id}/mark-vinci-uploaded',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Finalisation State
 * Lock / Vinci state for a response, so the UI can render the finalised
 * banner and the admin controls. Readable by the case's doctor or an admin.
 *
 * ``finalised_at`` is non-null once locked. Scoped through the case
 * (MDRS-567), so it can't be used to probe other doctors' cases.
 */
export const getFinalisationStateApiV1ReportGeneratorResponsesResponseIdFinalisationStateGet = <ThrowOnError extends boolean = false>(options: Options<GetFinalisationStateApiV1ReportGeneratorResponsesResponseIdFinalisationStateGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetFinalisationStateApiV1ReportGeneratorResponsesResponseIdFinalisationStateGetResponses, GetFinalisationStateApiV1ReportGeneratorResponsesResponseIdFinalisationStateGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/report-generator/responses/{response_id}/finalisation-state',
        ...options
    });
};

/**
 * Health Check
 * Check the health status of the bundle splitter API.
 */
export const healthCheckApiV1BundleSplitterHealthGet = <ThrowOnError extends boolean = false>(options?: Options<HealthCheckApiV1BundleSplitterHealthGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<HealthCheckApiV1BundleSplitterHealthGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/bundle-splitter/health',
        ...options
    });
};

/**
 * Get Bundle Splitter Sas Token
 * Generate a SAS token for uploading files to bundle splitter.
 * The file will be stored at: upload/{user.email}/{case_number}/bundle-splitter/{filename}
 */
export const getBundleSplitterSasTokenApiV1BundleSplitterGetSasTokenPost = <ThrowOnError extends boolean = false>(options: Options<GetBundleSplitterSasTokenApiV1BundleSplitterGetSasTokenPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetBundleSplitterSasTokenApiV1BundleSplitterGetSasTokenPostResponses, GetBundleSplitterSasTokenApiV1BundleSplitterGetSasTokenPostErrors, ThrowOnError>({
        ...urlSearchParamsBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/bundle-splitter/get-sas-token',
        ...options,
        headers: {
            'Content-Type': 'application/x-www-form-urlencoded',
            ...options.headers
        }
    });
};

/**
 * Classify Files
 * Submit files for classification to the bundle splitter API.
 *
 * This endpoint accepts either:
 * 1. Multiple PDF files uploaded directly (legacy method)
 * 2. List of file paths to files already uploaded to blob storage (new method for large files)
 *
 * Returns job information including task IDs that can be used to track progress and retrieve results.
 */
export const classifyFilesApiV1BundleSplitterClassifyPost = <ThrowOnError extends boolean = false>(options: Options<ClassifyFilesApiV1BundleSplitterClassifyPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ClassifyFilesApiV1BundleSplitterClassifyPostResponses, ClassifyFilesApiV1BundleSplitterClassifyPostErrors, ThrowOnError>({
        ...formDataBodySerializer,
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/bundle-splitter/classify',
        ...options,
        headers: {
            'Content-Type': null,
            ...options.headers
        }
    });
};

/**
 * Heartbeat Bundle Upload
 * The browser's upload is still running — keep the case "processing" (MDRS-508).
 *
 * Sent periodically while the file is on its way to blob storage. An upload
 * that stops sending these (network dropped, tab closed) stops counting
 * within ``UPLOAD_HEARTBEAT_TTL`` instead of blocking finalise for an hour.
 * Uploader-only; 404 for anyone else's upload or one that's already over.
 */
export const heartbeatBundleUploadApiV1BundleSplitterUploadsUploadIdHeartbeatPost = <ThrowOnError extends boolean = false>(options: Options<HeartbeatBundleUploadApiV1BundleSplitterUploadsUploadIdHeartbeatPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<HeartbeatBundleUploadApiV1BundleSplitterUploadsUploadIdHeartbeatPostResponses, HeartbeatBundleUploadApiV1BundleSplitterUploadsUploadIdHeartbeatPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/bundle-splitter/uploads/{upload_id}/heartbeat',
        ...options
    });
};

/**
 * Abandon Bundle Upload
 * The browser's upload failed — stop showing the case as receiving it (MDRS-508).
 *
 * Uploader-only; 404 for anyone else's upload or one that's already gone.
 */
export const abandonBundleUploadApiV1BundleSplitterUploadsUploadIdAbandonPost = <ThrowOnError extends boolean = false>(options: Options<AbandonBundleUploadApiV1BundleSplitterUploadsUploadIdAbandonPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<AbandonBundleUploadApiV1BundleSplitterUploadsUploadIdAbandonPostResponses, AbandonBundleUploadApiV1BundleSplitterUploadsUploadIdAbandonPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/bundle-splitter/uploads/{upload_id}/abandon',
        ...options
    });
};

/**
 * Get Task Status
 * Get the status of a classification task.
 *
 * Returns information about task progress, state, and whether it's ready.
 */
export const getTaskStatusApiV1BundleSplitterTasksTaskIdStatusGet = <ThrowOnError extends boolean = false>(options: Options<GetTaskStatusApiV1BundleSplitterTasksTaskIdStatusGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTaskStatusApiV1BundleSplitterTasksTaskIdStatusGetResponses, GetTaskStatusApiV1BundleSplitterTasksTaskIdStatusGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/bundle-splitter/tasks/{task_id}/status',
        ...options
    });
};

/**
 * Get Task Result
 * Get the result of a classification task.
 *
 * Returns the complete result data including blob URLs for the original bundle,
 * classification results, indexed PDF, and split documents.
 */
export const getTaskResultApiV1BundleSplitterTasksTaskIdResultGet = <ThrowOnError extends boolean = false>(options: Options<GetTaskResultApiV1BundleSplitterTasksTaskIdResultGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetTaskResultApiV1BundleSplitterTasksTaskIdResultGetResponses, GetTaskResultApiV1BundleSplitterTasksTaskIdResultGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/bundle-splitter/tasks/{task_id}/result',
        ...options
    });
};

/**
 * Cancel Task
 * Cancel a classification task.
 *
 * Cancels the task in the external bundle splitter API and updates
 * the local database record status to REVOKED.
 */
export const cancelTaskApiV1BundleSplitterTasksTaskIdCancelPost = <ThrowOnError extends boolean = false>(options: Options<CancelTaskApiV1BundleSplitterTasksTaskIdCancelPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CancelTaskApiV1BundleSplitterTasksTaskIdCancelPostResponses, CancelTaskApiV1BundleSplitterTasksTaskIdCancelPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/bundle-splitter/tasks/{task_id}/cancel',
        ...options
    });
};

/**
 * Classify Files By Request
 * Alternative endpoint to classify files using a JSON request body.
 *
 * This endpoint is useful when you need to pass file references or identifiers
 * instead of uploading files directly. The actual file handling would need to be
 * implemented based on your specific requirements.
 */
export const classifyFilesByRequestApiV1BundleSplitterClassifyByRequestPost = <ThrowOnError extends boolean = false>(options: Options<ClassifyFilesByRequestApiV1BundleSplitterClassifyByRequestPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ClassifyFilesByRequestApiV1BundleSplitterClassifyByRequestPostResponses, ClassifyFilesByRequestApiV1BundleSplitterClassifyByRequestPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/bundle-splitter/classify-by-request',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Save Classified Files
 * Save classified files from bundle splitter results to the correct Azure storage locations
 * and create database records for each file.
 *
 * This endpoint copies files from the bundle splitter locations to the correct
 * classification folders within the same Azure storage container, then creates DocSorterFile
 * records and triggers summary processing.
 */
export const saveClassifiedFilesApiV1BundleSplitterCaseCaseNumberSavePost = <ThrowOnError extends boolean = false>(options: Options<SaveClassifiedFilesApiV1BundleSplitterCaseCaseNumberSavePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<SaveClassifiedFilesApiV1BundleSplitterCaseCaseNumberSavePostResponses, SaveClassifiedFilesApiV1BundleSplitterCaseCaseNumberSavePostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/bundle-splitter/case/{case_number}/save',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Bundle Splitter Tasks
 * List bundle splitter tasks with optional filtering.
 *
 * Returns a paginated list of bundle splitter tasks for the current user.
 * Optionally filter by status and case_number.
 */
export const listBundleSplitterTasksApiV1BundleSplitterTasksGet = <ThrowOnError extends boolean = false>(options?: Options<ListBundleSplitterTasksApiV1BundleSplitterTasksGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListBundleSplitterTasksApiV1BundleSplitterTasksGetResponses, ListBundleSplitterTasksApiV1BundleSplitterTasksGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/bundle-splitter/tasks',
        ...options
    });
};

/**
 * Extract Snip Text
 * Extract text from a rectangular region on a PDF page.
 *
 * Queries stored OCR layout data and returns lines that intersect
 * the selection rectangle. If no layout data exists, triggers
 * re-processing to generate it.
 */
export const extractSnipTextApiV1OcrSnipExtractPost = <ThrowOnError extends boolean = false>(options: Options<ExtractSnipTextApiV1OcrSnipExtractPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ExtractSnipTextApiV1OcrSnipExtractPostResponses, ExtractSnipTextApiV1OcrSnipExtractPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/ocr-snip/extract',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Page Ocr Lines
 * Return every OCR line + bounding box on a page (MDRS-134).
 *
 * Drives semantic-search source highlighting: scanned PDFs have no browser
 * text layer, so the frontend matches the cited snippet against these OCR
 * lines and draws highlight rectangles over the matching ones. When no layout
 * exists yet, triggers re-processing and returns ``status="processing"`` so
 * the caller falls back to a plain page jump (no highlight).
 */
export const getPageOcrLinesApiV1OcrSnipLinesPost = <ThrowOnError extends boolean = false>(options: Options<GetPageOcrLinesApiV1OcrSnipLinesPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<GetPageOcrLinesApiV1OcrSnipLinesPostResponses, GetPageOcrLinesApiV1OcrSnipLinesPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/ocr-snip/lines',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Suremed Request Forms
 * Return the SureMed request-forms catalogue (request type -> groups).
 *
 * POC: served from config (``services/suremed/catalogue``); swaps to the live
 * request-forms discovery response later without a contract change.
 */
export const getSuremedRequestFormsApiV1ProvidersSuremedRequestFormsGet = <ThrowOnError extends boolean = false>(options?: Options<GetSuremedRequestFormsApiV1ProvidersSuremedRequestFormsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetSuremedRequestFormsApiV1ProvidersSuremedRequestFormsGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/providers/suremed/request-forms',
        ...options
    });
};

/**
 * List Document Requests
 */
export const listDocumentRequestsApiV1CasesCaseIdDocumentRequestsGet = <ThrowOnError extends boolean = false>(options: Options<ListDocumentRequestsApiV1CasesCaseIdDocumentRequestsGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<ListDocumentRequestsApiV1CasesCaseIdDocumentRequestsGetResponses, ListDocumentRequestsApiV1CasesCaseIdDocumentRequestsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/{case_id}/document-requests',
        ...options
    });
};

/**
 * Create Document Request
 */
export const createDocumentRequestApiV1CasesCaseIdDocumentRequestsPost = <ThrowOnError extends boolean = false>(options: Options<CreateDocumentRequestApiV1CasesCaseIdDocumentRequestsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateDocumentRequestApiV1CasesCaseIdDocumentRequestsPostResponses, CreateDocumentRequestApiV1CasesCaseIdDocumentRequestsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/{case_id}/document-requests',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Refresh Document Request
 * Check for updates (demo poll). Advances the simulated trickle: receives a
 * slice of pending components and ingests a placeholder document per newly
 * received item onto the case (appears in Assessment Prep). Real integration
 * replaces the simulation with a Konnect poll/webhook + document fetch.
 */
export const refreshDocumentRequestApiV1CasesCaseIdDocumentRequestsRequestIdRefreshPost = <ThrowOnError extends boolean = false>(options: Options<RefreshDocumentRequestApiV1CasesCaseIdDocumentRequestsRequestIdRefreshPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RefreshDocumentRequestApiV1CasesCaseIdDocumentRequestsRequestIdRefreshPostResponses, RefreshDocumentRequestApiV1CasesCaseIdDocumentRequestsRequestIdRefreshPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/cases/{case_id}/document-requests/{request_id}/refresh',
        ...options
    });
};

/**
 * List Provider Requests
 * The Requests referrers raised to the caller's provider, newest first.
 */
export const listProviderRequestsApiV1ProvidersMeDocumentRequestsGet = <ThrowOnError extends boolean = false>(options?: Options<ListProviderRequestsApiV1ProvidersMeDocumentRequestsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListProviderRequestsApiV1ProvidersMeDocumentRequestsGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/providers/me/document-requests',
        ...options
    });
};

/**
 * Get Provider Request
 * One request's detail — 404 unless it belongs to the caller's provider.
 */
export const getProviderRequestApiV1ProvidersMeDocumentRequestsRequestIdGet = <ThrowOnError extends boolean = false>(options: Options<GetProviderRequestApiV1ProvidersMeDocumentRequestsRequestIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetProviderRequestApiV1ProvidersMeDocumentRequestsRequestIdGetResponses, GetProviderRequestApiV1ProvidersMeDocumentRequestsRequestIdGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/providers/me/document-requests/{request_id}',
        ...options
    });
};

/**
 * Get Tags
 * Get all tags ordered alphabetically.
 */
export const getTagsApiV1TagsGet = <ThrowOnError extends boolean = false>(options?: Options<GetTagsApiV1TagsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetTagsApiV1TagsGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/tags/',
        ...options
    });
};

/**
 * Search Vinci
 * Search the Vinci replica by email/name to populate the add form.
 */
export const searchVinciApiV1AdminAccessListVinciSearchGet = <ThrowOnError extends boolean = false>(options: Options<SearchVinciApiV1AdminAccessListVinciSearchGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<SearchVinciApiV1AdminAccessListVinciSearchGetResponses, SearchVinciApiV1AdminAccessListVinciSearchGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/access-list/vinci-search',
        ...options
    });
};

/**
 * List Entries
 */
export const listEntriesApiV1AdminAccessListGet = <ThrowOnError extends boolean = false>(options?: Options<ListEntriesApiV1AdminAccessListGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListEntriesApiV1AdminAccessListGetResponses, ListEntriesApiV1AdminAccessListGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/access-list',
        ...options
    });
};

/**
 * Create Entry
 */
export const createEntryApiV1AdminAccessListPost = <ThrowOnError extends boolean = false>(options: Options<CreateEntryApiV1AdminAccessListPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<CreateEntryApiV1AdminAccessListPostResponses, CreateEntryApiV1AdminAccessListPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/access-list',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Delete Entry
 */
export const deleteEntryApiV1AdminAccessListEntryIdDelete = <ThrowOnError extends boolean = false>(options: Options<DeleteEntryApiV1AdminAccessListEntryIdDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<DeleteEntryApiV1AdminAccessListEntryIdDeleteResponses, DeleteEntryApiV1AdminAccessListEntryIdDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/access-list/{entry_id}',
        ...options
    });
};

/**
 * Update Entry
 */
export const updateEntryApiV1AdminAccessListEntryIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateEntryApiV1AdminAccessListEntryIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateEntryApiV1AdminAccessListEntryIdPatchResponses, UpdateEntryApiV1AdminAccessListEntryIdPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/access-list/{entry_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Get Catalogue
 * The togglable capabilities + configurable user types for the admin matrix.
 */
export const getCatalogueApiV1AdminAccessConfigCatalogueGet = <ThrowOnError extends boolean = false>(options?: Options<GetCatalogueApiV1AdminAccessConfigCatalogueGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<GetCatalogueApiV1AdminAccessConfigCatalogueGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/access-config/catalogue',
        ...options
    });
};

/**
 * List Access Config
 * Effective access config for every configurable user type.
 */
export const listAccessConfigApiV1AdminAccessConfigGet = <ThrowOnError extends boolean = false>(options?: Options<ListAccessConfigApiV1AdminAccessConfigGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListAccessConfigApiV1AdminAccessConfigGetResponses, unknown, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/access-config',
        ...options
    });
};

/**
 * Reset Access Config
 * Reset a user type to the hardcoded default (delete its config row).
 */
export const resetAccessConfigApiV1AdminAccessConfigUserTypeDelete = <ThrowOnError extends boolean = false>(options: Options<ResetAccessConfigApiV1AdminAccessConfigUserTypeDeleteData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).delete<ResetAccessConfigApiV1AdminAccessConfigUserTypeDeleteResponses, ResetAccessConfigApiV1AdminAccessConfigUserTypeDeleteErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/access-config/{user_type}',
        ...options
    });
};

/**
 * Set Access Config
 * Set a user type's enabled capabilities (replaces the whole set).
 */
export const setAccessConfigApiV1AdminAccessConfigUserTypePut = <ThrowOnError extends boolean = false>(options: Options<SetAccessConfigApiV1AdminAccessConfigUserTypePutData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).put<SetAccessConfigApiV1AdminAccessConfigUserTypePutResponses, SetAccessConfigApiV1AdminAccessConfigUserTypePutErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/access-config/{user_type}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Users
 * List all users (optionally filtered by email/name substring).
 */
export const listUsersApiV1AdminUsersGet = <ThrowOnError extends boolean = false>(options?: Options<ListUsersApiV1AdminUsersGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListUsersApiV1AdminUsersGetResponses, ListUsersApiV1AdminUsersGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users',
        ...options
    });
};

/**
 * Update User
 * Update a user's user_type and/or is_admin / is_blocked flags.
 */
export const updateUserApiV1AdminUsersUserIdPatch = <ThrowOnError extends boolean = false>(options: Options<UpdateUserApiV1AdminUsersUserIdPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<UpdateUserApiV1AdminUsersUserIdPatchResponses, UpdateUserApiV1AdminUsersUserIdPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/users/{user_id}',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Assign Case Referrer
 * Set ``Case.referrer_user_id`` (or clear it with ``null``).
 *
 * The target must be a ``referrer`` user — we don't allow assigning a doctor /
 * internal user as a case's referrer.
 */
export const assignCaseReferrerApiV1AdminCasesCaseIdReferrerPatch = <ThrowOnError extends boolean = false>(options: Options<AssignCaseReferrerApiV1AdminCasesCaseIdReferrerPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<AssignCaseReferrerApiV1AdminCasesCaseIdReferrerPatchResponses, AssignCaseReferrerApiV1AdminCasesCaseIdReferrerPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/cases/{case_id}/referrer',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Assign Case Doctor
 * Reassign the doctor who owns a case (MDRS-234).
 *
 * The exceptional path — mis-assignment or leave cover. Normal assignment is at
 * creation, because blob paths are prefixed with the owner's email: reassigning
 * a case that already has files leaves them under the previous owner's prefix,
 * so the new doctor won't see them until those blobs are moved.
 */
export const assignCaseDoctorApiV1AdminCasesCaseIdDoctorPatch = <ThrowOnError extends boolean = false>(options: Options<AssignCaseDoctorApiV1AdminCasesCaseIdDoctorPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<AssignCaseDoctorApiV1AdminCasesCaseIdDoctorPatchResponses, AssignCaseDoctorApiV1AdminCasesCaseIdDoctorPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/cases/{case_id}/doctor',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Set Case Doctor Ready
 * Flip the doctor-visibility gate on a case (MDRS-230).
 *
 * The admin creates the case, splits and categorises the bundle, reviews it,
 * then sets this to true — at which point the assigned doctor sees the case.
 * Reversible: setting it back to false pulls the case from their list again.
 */
export const setCaseDoctorReadyApiV1AdminCasesCaseIdDoctorReadyPatch = <ThrowOnError extends boolean = false>(options: Options<SetCaseDoctorReadyApiV1AdminCasesCaseIdDoctorReadyPatchData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).patch<SetCaseDoctorReadyApiV1AdminCasesCaseIdDoctorReadyPatchResponses, SetCaseDoctorReadyApiV1AdminCasesCaseIdDoctorReadyPatchErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/cases/{case_id}/doctor-ready',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Audit Events
 * Report audit log, newest first, real pagination. Admin-only.
 */
export const listAuditEventsApiV1AdminAuditEventsGet = <ThrowOnError extends boolean = false>(options?: Options<ListAuditEventsApiV1AdminAuditEventsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListAuditEventsApiV1AdminAuditEventsGetResponses, ListAuditEventsApiV1AdminAuditEventsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/admin/audit/events',
        ...options
    });
};

/**
 * Ingest Booking Approval
 * Upsert a booking into a pending approval (idempotent on booking id).
 */
export const ingestBookingApprovalApiV1IntakeBookingApprovalsPost = <ThrowOnError extends boolean = false>(options: Options<IngestBookingApprovalApiV1IntakeBookingApprovalsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IngestBookingApprovalApiV1IntakeBookingApprovalsPostResponses, IngestBookingApprovalApiV1IntakeBookingApprovalsPostErrors, ThrowOnError>({
        url: '/api/v1/intake/booking-approvals',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * List Booking Approvals
 * List booking approvals (newest first), optionally filtered.
 */
export const listBookingApprovalsApiV1BookingApprovalsGet = <ThrowOnError extends boolean = false>(options?: Options<ListBookingApprovalsApiV1BookingApprovalsGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<ListBookingApprovalsApiV1BookingApprovalsGetResponses, ListBookingApprovalsApiV1BookingApprovalsGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/booking-approvals/',
        ...options
    });
};

/**
 * Trigger Booking Sync
 * Admin-triggered "sync now" — poll the Vinci copy DB for new bookings.
 *
 * The sync uses synchronous pyodbc, so run it in a worker thread to avoid
 * blocking the event loop (a blocked loop stalls every other request and made
 * a slow sync surface as a gateway 504 that froze the whole backend).
 */
export const triggerBookingSyncApiV1BookingApprovalsSyncPost = <ThrowOnError extends boolean = false>(options?: Options<TriggerBookingSyncApiV1BookingApprovalsSyncPostData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).post<TriggerBookingSyncApiV1BookingApprovalsSyncPostResponses, TriggerBookingSyncApiV1BookingApprovalsSyncPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/booking-approvals/sync',
        ...options
    });
};

/**
 * Get Booking Approval
 * Fetch a single booking approval for the review screen.
 */
export const getBookingApprovalApiV1BookingApprovalsApprovalIdGet = <ThrowOnError extends boolean = false>(options: Options<GetBookingApprovalApiV1BookingApprovalsApprovalIdGetData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).get<GetBookingApprovalApiV1BookingApprovalsApprovalIdGetResponses, GetBookingApprovalApiV1BookingApprovalsApprovalIdGetErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/booking-approvals/{approval_id}',
        ...options
    });
};

/**
 * Approve Booking Approval
 * Approve a booking and promote it to a Report Studio case.
 *
 * Blocks (400) when mandatory fields are missing (AC #6); the case is created
 * for the matched ME with the default template. Any documents on the
 * booking snapshot are then pulled from Vinci into DocSorter as a background
 * task — approval doesn't wait on Vinci Documents API latency, and a broken
 * file (or no VINCI_DOCS_* config) never blocks the approval itself.
 */
export const approveBookingApprovalApiV1BookingApprovalsApprovalIdApprovePost = <ThrowOnError extends boolean = false>(options: Options<ApproveBookingApprovalApiV1BookingApprovalsApprovalIdApprovePostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<ApproveBookingApprovalApiV1BookingApprovalsApprovalIdApprovePostResponses, ApproveBookingApprovalApiV1BookingApprovalsApprovalIdApprovePostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/booking-approvals/{approval_id}/approve',
        ...options
    });
};

/**
 * Reject Booking Approval
 * Reject a pending booking approval with an optional reason.
 */
export const rejectBookingApprovalApiV1BookingApprovalsApprovalIdRejectPost = <ThrowOnError extends boolean = false>(options: Options<RejectBookingApprovalApiV1BookingApprovalsApprovalIdRejectPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<RejectBookingApprovalApiV1BookingApprovalsApprovalIdRejectPostResponses, RejectBookingApprovalApiV1BookingApprovalsApprovalIdRejectPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/booking-approvals/{approval_id}/reject',
        ...options,
        headers: {
            'Content-Type': 'application/json',
            ...options.headers
        }
    });
};

/**
 * Ingest Case Documents
 * Re-run ingestion of this case's Vinci documents through DocSorter.
 *
 * Takes **no request body** (MDRS-541 / audit AP-1). The document list is
 * resolved from the case's own booking approval; the caller chooses only
 * *which case* to re-ingest, and already has to own it. Previously the file
 * ids came from the request and were downloaded with the integration's own
 * Vinci credentials, so stepping through ids pulled other examinees'
 * documents into your own case.
 *
 * Fail-soft per file: files Vinci can't serve are reported in
 * `skipped_unavailable`, other errors in `failed`; the rest still ingest.
 */
export const ingestCaseDocumentsApiV1VinciCasesCaseIdIngestDocumentsPost = <ThrowOnError extends boolean = false>(options: Options<IngestCaseDocumentsApiV1VinciCasesCaseIdIngestDocumentsPostData, ThrowOnError>) => {
    return (options.client ?? _heyApiClient).post<IngestCaseDocumentsApiV1VinciCasesCaseIdIngestDocumentsPostResponses, IngestCaseDocumentsApiV1VinciCasesCaseIdIngestDocumentsPostErrors, ThrowOnError>({
        security: [
            {
                scheme: 'bearer',
                type: 'http'
            }
        ],
        url: '/api/v1/vinci/cases/{case_id}/ingest-documents',
        ...options
    });
};

/**
 * Main
 */
export const mainGet = <ThrowOnError extends boolean = false>(options?: Options<MainGetData, ThrowOnError>) => {
    return (options?.client ?? _heyApiClient).get<MainGetResponses, unknown, ThrowOnError>({
        url: '/',
        ...options
    });
};